import classnames from 'classnames'
import React from 'react'
import cls from './common.scss'

export function FilterIcon(props) {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M13.6875 4.5C14.1017 4.5 14.4375 4.83579 14.4375 5.25V8.25C14.4375 8.66421 14.1017 9 13.6875 9C13.2733 9 12.9375 8.66421 12.9375 8.25V7.5H5.4375C5.02329 7.5 4.6875 7.16421 4.6875 6.75C4.6875 6.33579 5.02329 6 5.4375 6H12.9375V5.25C12.9375 4.83579 13.2733 4.5 13.6875 4.5ZM15.9375 6.75C15.9375 6.33579 16.2733 6 16.6875 6H18.9375C19.3517 6 19.6875 6.33579 19.6875 6.75C19.6875 7.16421 19.3517 7.5 18.9375 7.5H16.6875C16.2733 7.5 15.9375 7.16421 15.9375 6.75ZM11.4375 9.75C11.8517 9.75 12.1875 10.0858 12.1875 10.5V11.25H19.6875C20.1017 11.25 20.4375 11.5858 20.4375 12C20.4375 12.4142 20.1017 12.75 19.6875 12.75H12.1875V13.5C12.1875 13.9142 11.8517 14.25 11.4375 14.25C11.0233 14.25 10.6875 13.9142 10.6875 13.5V10.5C10.6875 10.0858 11.0233 9.75 11.4375 9.75ZM4.6875 12C4.6875 11.5858 5.02329 11.25 5.4375 11.25H8.4375C8.85171 11.25 9.1875 11.5858 9.1875 12C9.1875 12.4142 8.85171 12.75 8.4375 12.75H5.4375C5.02329 12.75 4.6875 12.4142 4.6875 12ZM13.6875 15C14.1017 15 14.4375 15.3358 14.4375 15.75V18.75C14.4375 19.1642 14.1017 19.5 13.6875 19.5C13.2733 19.5 12.9375 19.1642 12.9375 18.75V18H5.4375C5.02329 18 4.6875 17.6642 4.6875 17.25C4.6875 16.8358 5.02329 16.5 5.4375 16.5H12.9375V15.75C12.9375 15.3358 13.2733 15 13.6875 15ZM15.9375 17.25C15.9375 16.8358 16.2733 16.5 16.6875 16.5H18.9375C19.3517 16.5 19.6875 16.8358 19.6875 17.25C19.6875 17.6642 19.3517 18 18.9375 18H16.6875C16.2733 18 15.9375 17.6642 15.9375 17.25Z"
        fill="#50565E"
        fillRule="evenodd"
      />
    </svg>
  )
}

export function DoneIcon(props) {
  return (
    <svg
      className={cls.hoverable}
      height={18}
      viewBox="0 0 24 24"
      width={18}
      {...props}
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M9 16.2l-3.5-3.5a.984.984 0 00-1.4 0 .984.984 0 000 1.4l4.19 4.19c.39.39 1.02.39 1.41 0L20.3 7.7a.984.984 0 000-1.4.984.984 0 00-1.4 0L9 16.2z" />
    </svg>
  )
}

export function EditIcon(props) {
  return (
    <svg
      className={cls.hoverable}
      height={18}
      style={{ transform: 'scale(0.8)', fill: '#023f62' }}
      viewBox="0 0 24 24"
      width={18}
      {...props}
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M3 17.46v3.04c0 .28.22.5.5.5h3.04c.13 0 .26-.05.35-.15L17.81 9.94l-3.75-3.75L3.15 17.1c-.1.1-.15.22-.15.36zM20.71 7.04a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
    </svg>
  )
}

export function CommentIcon() {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M5.625 5.25C5.625 4.42157 6.29657 3.75 7.125 3.75H14.625C14.8239 3.75 15.0147 3.82902 15.1553 3.96967L18.9053 7.71967C19.046 7.86032 19.125 8.05109 19.125 8.25V18.75C19.125 19.5784 18.4534 20.25 17.625 20.25H7.125C6.29658 20.25 5.625 19.5784 5.625 18.75V5.25ZM14.3143 5.25H7.125V18.75H17.625V8.56066L14.3143 5.25ZM8.625 10.5C8.625 10.0858 8.96079 9.75 9.375 9.75H15.375C15.7892 9.75 16.125 10.0858 16.125 10.5C16.125 10.9142 15.7892 11.25 15.375 11.25H9.375C8.96079 11.25 8.625 10.9142 8.625 10.5ZM8.625 13.5C8.625 13.0858 8.96079 12.75 9.375 12.75H15.375C15.7892 12.75 16.125 13.0858 16.125 13.5C16.125 13.9142 15.7892 14.25 15.375 14.25H9.375C8.96079 14.25 8.625 13.9142 8.625 13.5Z"
        fill="#50565E"
        fillRule="evenodd"
      />
    </svg>
  )
}

export function ArrowDown(props) {
  return (
    <svg
      fill="none"
      height="14"
      viewBox="0 0 14 14"
      width="14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M3.37886 4.83748C3.60667 4.60967 3.97601 4.60967 4.20382 4.83748L7.29134 7.925L10.3789 4.83748C10.6067 4.60967 10.976 4.60967 11.2038 4.83748C11.4316 5.06529 11.4316 5.43463 11.2038 5.66244L7.70382 9.16244C7.47601 9.39024 7.10667 9.39024 6.87886 9.16244L3.37886 5.66244C3.15106 5.43463 3.15106 5.06529 3.37886 4.83748Z"
        fill={props.active === 'active' ? '#33bead' : '#888e96'}
        fillRule="evenodd"
      />
    </svg>
  )
}

export function PlusIcon(props) {
  return (
    <svg
      className={cls.hoverable}
      height={18}
      viewBox="0 0 14 14"
      width={18}
      {...props}
    >
      <path
        d="M7.736 1.167A5.835 5.835 0 001.903 7a5.835 5.835 0 005.833 5.833A5.835 5.835 0 0013.569 7a5.835 5.835 0 00-5.833-5.833zm2.333 6.416H8.32v1.75c0 .321-.262.584-.583.584a.585.585 0 01-.583-.584v-1.75h-1.75A.585.585 0 014.819 7c0-.32.263-.583.584-.583h1.75v-1.75c0-.321.262-.584.583-.584.32 0 .583.263.583.584v1.75h1.75c.321 0 .584.262.584.583 0 .32-.263.583-.584.583z"
        fill="#50565E"
        fillRule="evenodd"
      />
    </svg>
  )
}

export function MinusIcon(props) {
  return (
    <svg
      className={cls.hoverable}
      height={18}
      viewBox="0 0 14 14"
      width={18}
      {...props}
    >
      <path
        d="M7.736 1.167A5.835 5.835 0 001.903 7a5.835 5.835 0 005.833 5.833A5.835 5.835 0 0013.569 7a5.835 5.835 0 00-5.833-5.833zm2.333 6.416H5.403A.585.585 0 014.819 7c0-.32.263-.583.584-.583h4.666c.321 0 .584.262.584.583 0 .32-.263.583-.584.583z"
        fill="#50565E"
        fillRule="evenodd"
      />
    </svg>
  )
}
export function CustomersIcon(props) {
  return (
    <svg
      className={cls.mr5}
      height={24}
      viewBox="0 0 25 24"
      width={25}
      {...props}
    >
      <path
        d="M20.736 6.5h-4v-2c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2h-4c-1.11 0-1.99.89-1.99 2l-.01 11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2v-11c0-1.11-.89-2-2-2zm-6 0h-4v-2h4v2z"
        fill="#FFF"
        fillRule="evenodd"
      />
    </svg>
  )
}
export const ArrowIcon = (props) => (
  <svg
    className={classnames(cls.arrow_collapse, {
      [cls.collapse_show]: props.expanded,
    })}
    height={24}
    onClick={props.onClick}
    width={24}
  >
    <path d="M9.29 15.88L13.17 12 9.29 8.12a.996.996 0 111.41-1.41l4.59 4.59c.39.39.39 1.02 0 1.41L10.7 17.3a.996.996 0 01-1.41 0c-.38-.39-.39-1.03 0-1.42z" />
  </svg>
)

export const DateIcon = (props) => (
  <svg className={cls.icon_date} height={20} width={20} {...props}>
    <path
      d="M13.333 10.833h-2.5a.836.836 0 00-.833.834v2.5c0 .458.375.833.833.833h2.5a.836.836 0 00.834-.833v-2.5a.836.836 0 00-.834-.834zm0-8.333v.833H6.667V2.5a.836.836 0 00-.834-.833A.836.836 0 005 2.5v.833h-.833A1.66 1.66 0 002.508 5L2.5 16.667c0 .916.742 1.666 1.667 1.666h11.666c.917 0 1.667-.75 1.667-1.666V5c0-.917-.75-1.667-1.667-1.667H15V2.5a.836.836 0 00-.833-.833.836.836 0 00-.834.833zM15 16.667H5a.836.836 0 01-.833-.834V7.5h11.666v8.333a.836.836 0 01-.833.834z"
      fill="#50565E"
      fillRule="evenodd"
      style={{ fill: '#50565e' }}
    />
  </svg>
)

export const DateIconNew = () => (
  <svg
    aria-hidden="true"
    data-icon="calendar"
    fill="#50565e"
    focusable="false"
    height="1em"
    viewBox="64 64 896 896"
    width="1em"
  >
    <path d="M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z" />
  </svg>
)

export function Plus({ fill, className }) {
  return (
    <svg
      className={className}
      fill="none"
      height="18"
      viewBox="0 0 18 18"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M9.02375 3C9.43796 3.00054 9.7733 3.33677 9.77276 3.75098L9.76686 8.25H14.25C14.6642 8.25 15 8.58579 15 9C15 9.41421 14.6642 9.75 14.25 9.75H9.7649L9.759 14.251C9.75846 14.6652 9.42223 15.0005 9.00802 15C8.5938 14.9995 8.25846 14.6632 8.259 14.249L8.2649 9.75H3.75C3.33579 9.75 3 9.41421 3 9C3 8.58579 3.33579 8.25 3.75 8.25H8.26686L8.27276 3.74902C8.27331 3.3348 8.60953 2.99946 9.02375 3Z"
        fill={fill || '#fff'}
        fillRule="evenodd"
      />
    </svg>
  )
}

export function Upload({ className }) {
  return (
    <svg
      className={className}
      fill="none"
      height="18"
      viewBox="0 0 18 18"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M1.35587 5.25033C2.5577 2.94476 5.05663 1.6189 7.63958 1.9164C10.0258 2.19123 12.0272 3.79899 12.8277 6.02796H13.1441C14.8912 6.02682 16.6373 6.95018 17.215 8.7735C17.7688 10.5217 17.1256 12.4272 15.6255 13.4821C15.2867 13.7203 14.8189 13.6388 14.5806 13.3C14.3424 12.9611 14.4239 12.4933 14.7627 12.2551C15.7276 11.5766 16.1413 10.351 15.785 9.22654C15.4526 8.17742 14.4114 7.52698 13.1453 7.52796L12.2743 7.52796C11.9319 7.52796 11.633 7.29604 11.5479 6.96437C11.0561 5.04786 9.43356 3.63294 7.46795 3.40655C5.5023 3.18015 3.60061 4.18914 2.68601 5.94369C1.77141 7.69824 2.0333 9.83505 3.34454 11.3168C3.61904 11.627 3.59011 12.101 3.27991 12.3755C2.96971 12.65 2.49572 12.6211 2.22122 12.3109C0.498187 10.3638 0.154048 7.5559 1.35587 5.25033ZM8.46955 7.44673C8.76244 7.15384 9.23731 7.15384 9.5302 7.44673L11.9167 9.83319C12.2096 10.1261 12.2096 10.601 11.9167 10.8938C11.6238 11.1867 11.1489 11.1867 10.856 10.8939L9.75038 9.78821L9.75299 15.3747C9.75318 15.7889 9.41755 16.1248 9.00334 16.125C8.58912 16.1252 8.25318 15.7896 8.25299 15.3754L8.25038 9.7872L7.1437 10.8939C6.85081 11.1867 6.37593 11.1867 6.08304 10.8938C5.79015 10.601 5.79015 10.1261 6.08305 9.83319L8.46955 7.44673Z"
        fill="#B2B8C0"
        fillRule="evenodd"
      />
    </svg>
  )
}

export const DeleteSearch = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    className={cls.delete}
    height="16"
    viewBox="0 0 24 24"
    width="16"
  >
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z" />
  </svg>
)

export const DeleteSearch2 = (props) => (
  <svg
    style={{ cursor: 'pointer' }}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    height="16"
    viewBox="0 0 24 24"
    width="16"
  >
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z" />
  </svg>
)

export function SearchIcon() {
  return (
    <svg
      className={cls.search}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M4.125 10.875C4.125 6.93999 7.31499 3.75 11.25 3.75C15.185 3.75 18.375 6.93999 18.375 10.875C18.375 12.5724 17.7815 14.1311 16.7906 15.355L19.5455 18.1098C19.8384 18.4027 19.8384 18.8776 19.5455 19.1705C19.2526 19.4634 18.7777 19.4634 18.4848 19.1705L15.73 16.4156C14.5061 17.4065 12.9474 18 11.25 18C7.31499 18 4.125 14.81 4.125 10.875ZM11.25 5.25C8.14341 5.25 5.625 7.76841 5.625 10.875C5.625 13.9816 8.14341 16.5 11.25 16.5C14.3566 16.5 16.875 13.9816 16.875 10.875C16.875 7.76841 14.3566 5.25 11.25 5.25ZM8.59835 7.84831C9.27617 7.17054 10.2147 6.75 11.25 6.75C12.2853 6.75 13.2238 7.17054 13.9016 7.84833C14.1945 8.14123 14.1945 8.6161 13.9016 8.90899C13.6087 9.20189 13.1339 9.20189 12.841 8.90899C12.433 8.50101 11.8715 8.25 11.25 8.25C10.6285 8.25 10.067 8.50101 9.65897 8.90901C9.36607 9.20189 8.8912 9.20188 8.59831 8.90897C8.30543 8.61607 8.30545 8.1412 8.59835 7.84831Z"
        fill="#50565E"
        fillRule="evenodd"
      />
    </svg>
  )
}

export const DotsComponent = (props) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    className={cls.hoverable}
  >
    <path
      d="M7.875 13.125C8.49632 13.125 9 12.6213 9 12C9 11.3787 8.49632 10.875 7.875 10.875C7.25368 10.875 6.75 11.3787 6.75 12C6.75 12.6213 7.25368 13.125 7.875 13.125Z"
      fill="#50565E"
    />
    <path
      d="M12.375 13.125C12.9963 13.125 13.5 12.6213 13.5 12C13.5 11.3787 12.9963 10.875 12.375 10.875C11.7537 10.875 11.25 11.3787 11.25 12C11.25 12.6213 11.7537 13.125 12.375 13.125Z"
      fill="#50565E"
    />
    <path
      d="M16.875 13.125C17.4963 13.125 18 12.6213 18 12C18 11.3787 17.4963 10.875 16.875 10.875C16.2537 10.875 15.75 11.3787 15.75 12C15.75 12.6213 16.2537 13.125 16.875 13.125Z"
      fill="#50565E"
    />
  </svg>
)

export const ArrowDropdown = (props) => (
  <div className={cls.hoverable}>
    <svg height={20} viewBox="0 0 21 20" width={21} {...props}>
      <path
        d="M7.507 7.5l3.233 3.233L13.973 7.5a.83.83 0 111.175 1.175L11.323 12.5a.83.83 0 01-1.175 0L6.323 8.675a.83.83 0 010-1.175.848.848 0 011.184 0z"
        fill="#50565E"
        fillRule="evenodd"
      />
    </svg>
  </div>
)

export const TogglePassword = () => (
  <svg height={20} width={20}>
    <path
      d="M10 .75C5.833.75 2.275 3.342.833 7c1.442 3.658 5 6.25 9.167 6.25s7.725-2.592 9.167-6.25C17.725 3.342 14.167.75 10 .75zm0 10.417A4.168 4.168 0 015.833 7C5.833 4.7 7.7 2.833 10 2.833S14.167 4.7 14.167 7 12.3 11.167 10 11.167zM10 4.5A2.497 2.497 0 007.5 7c0 1.383 1.117 2.5 2.5 2.5s2.5-1.117 2.5-2.5-1.117-2.5-2.5-2.5z"
      fill="#B2B8C0"
      fillRule="evenodd"
    />
  </svg>
)

export const PreferencesIcon = (props) => (
  <svg className={cls.mr5} height={24} width={24} {...props}>
    <path
      d="M19.432 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65a.488.488 0 00-.49-.42h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-7.43 2.52c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
      fill="#FFF"
      fillRule="evenodd"
    />
  </svg>
)

export const TrucksIcon = (props) => (
  <svg className={cls.mr5} height={24} width={24} {...props}>
    <path
      d="M19.5 8H17V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2 0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h1c.55 0 1-.45 1-1v-3.33c0-.43-.14-.85-.4-1.2L20.3 8.4c-.19-.25-.49-.4-.8-.4zM6 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm13.5-8.5l1.96 2.5H17V9.5h2.5zM18 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
      fill="#FFF"
      fillRule="evenodd"
    />
  </svg>
)

export const DriversIcon = (props) => (
  <svg className={cls.mr5} height={24} width={24} {...props}>
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm3.61 6.34c1.07 0 1.93.86 1.93 1.93 0 1.07-.86 1.93-1.93 1.93-1.07 0-1.93-.86-1.93-1.93-.01-1.07.86-1.93 1.93-1.93zm-6-1.58c1.3 0 2.36 1.06 2.36 2.36 0 1.3-1.06 2.36-2.36 2.36-1.3 0-2.36-1.06-2.36-2.36 0-1.31 1.05-2.36 2.36-2.36zm0 9.13v3.75c-2.4-.75-4.3-2.6-5.14-4.96 1.05-1.12 3.67-1.69 5.14-1.69.53 0 1.2.08 1.9.22-1.64.87-1.9 2.02-1.9 2.68zM12 20c-.27 0-.53-.01-.79-.04v-4.07c0-1.42 2.94-2.13 4.4-2.13 1.07 0 2.92.39 3.84 1.15C18.28 17.88 15.39 20 12 20z"
      fill="#FFF"
      fillRule="evenodd"
    />
  </svg>
)

export const VendorsIcon = (props) => (
  <svg className={cls.mr5} height={24} width={24} {...props}>
    <path
      d="M12 7V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2h-8zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm9 12h-7v-2h2v-2h-2v-2h2v-2h-2V9h7c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1zm-1-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
      fill="#FFF"
      fillRule="evenodd"
    />
  </svg>
)

export const LoadTripIcon = (props) => (
  <svg className={cls.mr5} height={24} width={24} {...props}>
    <path
      d="M12 2.265c-3.87 0-7 3.13-7 7 0 4.17 4.42 9.92 6.24 12.11.4.48 1.13.48 1.53 0 1.81-2.19 6.23-7.94 6.23-12.11 0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"
      fill="#FFF"
      fillRule="evenodd"
    />
  </svg>
)

export const DashboardIcon = (props) => (
  <svg className={cls.mr5} height={24} width={24} {...props}>
    <path
      d="M4 13h6c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1zm0 8h6c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm10 0h6c.55 0 1-.45 1-1v-8c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1zM13 4v4c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1z"
      fill="#FFF"
      fillRule="evenodd"
    />
  </svg>
)

export const MarkerIcon = () => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.375 3.75C15.8958 3.75 18.75 6.60417 18.75 10.125C18.75 12.3642 17.7167 14.6285 15.9891 16.8379C15.376 17.6221 14.7091 18.3533 14.026 19.0192C13.9697 19.0741 13.9144 19.1275 13.8601 19.1794L13.5466 19.4735L13.2605 19.7313L13.0049 19.9521L12.8488 20.0814C12.5749 20.3046 12.1824 20.3064 11.9065 20.0857L11.7433 19.9506L11.4889 19.7308L11.2033 19.4733L10.8899 19.1794L10.724 19.0192C10.0409 18.3533 9.37404 17.6221 8.7609 16.8379C7.03335 14.6285 6 12.3642 6 10.125C6 6.60417 8.85417 3.75 12.375 3.75ZM12.375 5.25C9.6826 5.25 7.5 7.4326 7.5 10.125C7.5 11.9671 8.40209 13.9438 9.94257 15.914C10.5113 16.6414 11.1335 17.3236 11.7711 17.9451L12.0731 18.2341C12.1726 18.3274 12.2723 18.4209 12.375 18.5107L12.6769 18.2341L12.9789 17.9451C13.6165 17.3236 14.2387 16.6414 14.8074 15.914C16.3479 13.9438 17.25 11.9671 17.25 10.125C17.25 7.4326 15.0674 5.25 12.375 5.25ZM12.375 7.125C14.0319 7.125 15.375 8.46815 15.375 10.125C15.375 11.7819 14.0319 13.125 12.375 13.125C10.7181 13.125 9.375 11.7819 9.375 10.125C9.375 8.46815 10.7181 7.125 12.375 7.125ZM12.375 8.625C11.5466 8.625 10.875 9.29658 10.875 10.125C10.875 10.9534 11.5466 11.625 12.375 11.625C13.2034 11.625 13.875 10.9534 13.875 10.125C13.875 9.29658 13.2034 8.625 12.375 8.625Z"
      fill="#50565E"
    />
  </svg>
)

export const IconTrackingOff = () => (
  <svg
    className="cursor-not-allowed"
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M16.8223 9.75C16.8223 7.68 15.1423 6 13.0723 6C12.1123 6 11.2423 6.375 10.5823 6.9675L9.50977 5.895C10.4473 5.0325 11.6923 4.5 13.0723 4.5C15.9748 4.5 18.3223 6.8475 18.3223 9.75C18.3223 10.9275 17.8498 12.27 17.1898 13.5825L16.0723 12.465C16.5298 11.49 16.8223 10.545 16.8223 9.75ZM11.9023 8.295C12.2248 8.0325 12.6298 7.875 13.0723 7.875C14.1073 7.875 14.9473 8.715 14.9473 9.75C14.9473 10.1925 14.7898 10.5975 14.5273 10.92L11.9023 8.295ZM6.62977 5.145L5.57227 6.2025L7.95727 8.5875C7.87477 8.9625 7.82227 9.3525 7.82227 9.75C7.82227 13.6875 13.0723 19.5 13.0723 19.5C13.0723 19.5 14.3248 18.1125 15.6073 16.2375L18.1198 18.75L19.1773 17.6925L6.62977 5.145ZM9.33727 9.9675C9.47227 12.105 11.5648 15.225 13.0723 17.16C13.5298 16.575 14.0398 15.8925 14.5273 15.1575L9.33727 9.9675Z"
      fill="#50565E"
      fillRule="evenodd"
    />
  </svg>
)

export const IconTrackingInactive = () => (
  <svg
    className="cursor-not-allowed"
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.375 3.75C15.8958 3.75 18.75 6.60417 18.75 10.125C18.75 12.3642 17.7167 14.6285 15.9891 16.8379C15.376 17.6221 14.7091 18.3533 14.026 19.0192C13.9697 19.0741 13.9144 19.1275 13.8601 19.1794L13.5466 19.4735L13.2605 19.7313L13.0049 19.9521L12.8488 20.0814C12.5749 20.3046 12.1824 20.3064 11.9065 20.0857L11.7433 19.9506L11.4889 19.7308L11.2033 19.4733L10.8899 19.1794L10.724 19.0192C10.0409 18.3533 9.37404 17.6221 8.7609 16.8379C7.03335 14.6285 6 12.3642 6 10.125C6 6.60417 8.85417 3.75 12.375 3.75ZM12.375 5.25C9.6826 5.25 7.5 7.4326 7.5 10.125C7.5 11.9671 8.40209 13.9438 9.94257 15.914C10.5113 16.6414 11.1335 17.3236 11.7711 17.9451L12.0731 18.2341C12.1726 18.3274 12.2723 18.4209 12.375 18.5107L12.6769 18.2341L12.9789 17.9451C13.6165 17.3236 14.2387 16.6414 14.8074 15.914C16.3479 13.9438 17.25 11.9671 17.25 10.125C17.25 7.4326 15.0674 5.25 12.375 5.25ZM12.375 7.125C14.0319 7.125 15.375 8.46815 15.375 10.125C15.375 11.7819 14.0319 13.125 12.375 13.125C10.7181 13.125 9.375 11.7819 9.375 10.125C9.375 8.46815 10.7181 7.125 12.375 7.125ZM12.375 8.625C11.5466 8.625 10.875 9.29658 10.875 10.125C10.875 10.9534 11.5466 11.625 12.375 11.625C13.2034 11.625 13.875 10.9534 13.875 10.125C13.875 9.29658 13.2034 8.625 12.375 8.625Z"
      fill="#B2B8C0"
    />
  </svg>
)

export const EditIconSquare = () => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M4.875 6C4.875 5.17157 5.54657 4.5 6.375 4.5H11.625C12.0392 4.5 12.375 4.83579 12.375 5.25C12.375 5.66421 12.0392 6 11.625 6H6.375V18H18.375V12.75C18.375 12.3358 18.7108 12 19.125 12C19.5392 12 19.875 12.3358 19.875 12.75V18C19.875 18.8284 19.2034 19.5 18.375 19.5H6.375C5.54658 19.5 4.875 18.8284 4.875 18V6ZM16.3855 4.5C16.5845 4.49996 16.7754 4.57903 16.9161 4.71979L19.6554 7.46032C19.9482 7.75319 19.9482 8.22788 19.6554 8.52075L11.8994 16.2802C11.7587 16.4209 11.5679 16.5 11.3689 16.5H8.625C8.21079 16.5 7.875 16.1642 7.875 15.75V13.02C7.875 12.8212 7.95389 12.6306 8.09435 12.49L15.855 4.71999C15.9957 4.57918 16.1865 4.50004 16.3855 4.5ZM16.3859 6.31109L9.375 13.3304V15H11.0582L18.0646 7.99054L16.3859 6.31109Z"
      fill="#50565E"
      fillRule="evenodd"
    />
  </svg>
)
export const DeactivateIconSquare = () => (
  <svg
    fill="none"
    height="15"
    viewBox="0 0 14 15"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.78715 4.4622C4.55935 4.23439 4.19 4.23439 3.9622 4.4622C3.73439 4.69 3.73439 5.05935 3.9622 5.28715L9.2122 10.5372C9.44 10.765 9.80935 10.765 10.0372 10.5372C10.265 10.3093 10.265 9.94 10.0372 9.7122L4.78715 4.4622Z"
      fill="#FF212C"
    />
    <path
      clipRule="evenodd"
      d="M6.99967 1.08301C3.45585 1.08301 0.583008 3.95585 0.583008 7.49967C0.583008 11.0435 3.45585 13.9163 6.99967 13.9163C10.5435 13.9163 13.4163 11.0435 13.4163 7.49967C13.4163 3.95585 10.5435 1.08301 6.99967 1.08301ZM1.74967 7.49967C1.74967 4.60018 4.10018 2.24967 6.99967 2.24967C9.89917 2.24967 12.2497 4.60018 12.2497 7.49967C12.2497 10.3992 9.89917 12.7497 6.99967 12.7497C4.10018 12.7497 1.74967 10.3992 1.74967 7.49967Z"
      fill="#FF212C"
      fillRule="evenodd"
    />
  </svg>
)
export const ResendIconSquare = () => (
  <svg
    fill="none"
    height="15"
    viewBox="0 0 14 15"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.2926 4.20384C9.44677 3.35801 8.28594 2.83301 6.99677 2.83301C4.41844 2.83301 2.33594 4.92134 2.33594 7.49967C2.33594 10.078 4.41844 12.1663 6.99677 12.1663C9.1726 12.1663 10.9868 10.6788 11.5059 8.66634H10.2926C9.81427 10.0255 8.51927 10.9997 6.99677 10.9997C5.06594 10.9997 3.49677 9.43051 3.49677 7.49967C3.49677 5.56884 5.06594 3.99967 6.99677 3.99967C7.9651 3.99967 8.82844 4.40217 9.45844 5.03801L7.5801 6.91634H11.6634V2.83301L10.2926 4.20384Z"
      fill="#50565E"
    />
  </svg>
)
export const MyAccountIcon = () => (
  <svg
    fill="none"
    height="15"
    viewBox="0 0 14 15"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M0.583496 1.66683C0.583496 1.34466 0.844663 1.0835 1.16683 1.0835H3.50016C3.82233 1.0835 4.0835 1.34466 4.0835 1.66683C4.0835 1.989 3.82233 2.25016 3.50016 2.25016H1.75016V4.00016C1.75016 4.32233 1.489 4.5835 1.16683 4.5835C0.844663 4.5835 0.583496 4.32233 0.583496 4.00016V1.66683ZM9.91683 1.66683C9.91683 1.34466 10.178 1.0835 10.5002 1.0835H12.8335C13.1557 1.0835 13.4168 1.34466 13.4168 1.66683V4.00016C13.4168 4.32233 13.1557 4.5835 12.8335 4.5835C12.5113 4.5835 12.2502 4.32233 12.2502 4.00016V2.25016H10.5002C10.178 2.25016 9.91683 1.989 9.91683 1.66683ZM7.00016 4.00016C6.35583 4.00016 5.8335 4.5225 5.8335 5.16683C5.8335 5.81116 6.35583 6.3335 7.00016 6.3335C7.64449 6.3335 8.16683 5.81116 8.16683 5.16683C8.16683 4.5225 7.64449 4.00016 7.00016 4.00016ZM4.66683 5.16683C4.66683 3.87816 5.7115 2.8335 7.00016 2.8335C8.28883 2.8335 9.3335 3.87816 9.3335 5.16683C9.3335 5.98432 8.91309 6.70362 8.27669 7.12033C9.90667 7.65631 11.0835 9.19081 11.0835 11.0002C11.0835 11.3223 10.8223 11.5835 10.5002 11.5835C10.178 11.5835 9.91683 11.3223 9.91683 11.0002C9.91683 9.38934 8.61099 8.0835 7.00016 8.0835C5.38934 8.0835 4.0835 9.38934 4.0835 11.0002C4.0835 11.3223 3.82233 11.5835 3.50016 11.5835C3.178 11.5835 2.91683 11.3223 2.91683 11.0002C2.91683 9.19081 4.09365 7.65631 5.72363 7.12033C5.08723 6.70362 4.66683 5.98432 4.66683 5.16683ZM1.16683 10.4168C1.489 10.4168 1.75016 10.678 1.75016 11.0002V12.7502H3.50016C3.82233 12.7502 4.0835 13.0113 4.0835 13.3335C4.0835 13.6557 3.82233 13.9168 3.50016 13.9168H1.16683C0.844663 13.9168 0.583496 13.6557 0.583496 13.3335V11.0002C0.583496 10.678 0.844663 10.4168 1.16683 10.4168ZM12.8335 10.4168C13.1557 10.4168 13.4168 10.678 13.4168 11.0002V13.3335C13.4168 13.6557 13.1557 13.9168 12.8335 13.9168H10.5002C10.178 13.9168 9.91683 13.6557 9.91683 13.3335C9.91683 13.0113 10.178 12.7502 10.5002 12.7502H12.2502V11.0002C12.2502 10.678 12.5113 10.4168 12.8335 10.4168Z"
      fill="#50565E"
      fillRule="evenodd"
    />
  </svg>
)
export const LogoutIcon = () => (
  <svg
    fill="none"
    height="15"
    viewBox="0 0 14 15"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.1665 2.24984C1.1665 1.92767 1.42767 1.6665 1.74984 1.6665H6.99742C7.31958 1.6665 7.58075 1.92767 7.58075 2.24984C7.58075 2.572 7.31958 2.83317 6.99742 2.83317H2.33317V12.1665H6.99984C7.322 12.1665 7.58317 12.4277 7.58317 12.7498C7.58317 13.072 7.322 13.3332 6.99984 13.3332H1.74984C1.42767 13.3332 1.1665 13.072 1.1665 12.7498V2.24984Z"
      fill="#50565E"
    />
    <path
      d="M9.21236 4.46236C9.44016 4.23455 9.80951 4.23455 10.0373 4.46236L12.6304 7.05549C12.7546 7.16246 12.8332 7.32083 12.8332 7.49756L12.8332 7.49863C12.8335 7.64832 12.7765 7.79811 12.6623 7.91232L10.0373 10.5373C9.80951 10.7651 9.44016 10.7651 9.21236 10.5373C8.98455 10.3095 8.98455 9.94016 9.21236 9.71236L10.8438 8.08089H4.6665C4.34434 8.08089 4.08317 7.81973 4.08317 7.49756C4.08317 7.17539 4.34434 6.91423 4.6665 6.91423H10.8393L9.21236 5.28732C8.98455 5.05951 8.98455 4.69016 9.21236 4.46236Z"
      fill="#50565E"
    />
  </svg>
)

export const ActiveIconSquare = () => (
  <svg
    fill="none"
    height="15"
    viewBox="0 0 14 15"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.58301 1.66634C7.58301 1.34418 7.32184 1.08301 6.99967 1.08301C6.67751 1.08301 6.41634 1.34418 6.41634 1.66634V2.83301C6.41634 3.15517 6.67751 3.41634 6.99967 3.41634C7.32184 3.41634 7.58301 3.15517 7.58301 2.83301V1.66634Z"
      fill="#50565E"
    />
    <path
      d="M10.4215 2.73959C10.5826 2.46058 10.487 2.10382 10.208 1.94274C9.92901 1.78165 9.57225 1.87724 9.41116 2.15625L8.82783 3.1666C8.66674 3.4456 8.76233 3.80236 9.04134 3.96345C9.32034 4.12453 9.6771 4.02894 9.83819 3.74994L10.4215 2.73959Z"
      fill="#50565E"
    />
    <path
      d="M12.5567 4.29134C12.7178 4.57034 12.6222 4.92711 12.3432 5.08819L11.3328 5.67152C11.0538 5.83261 10.697 5.73701 10.536 5.45801C10.3749 5.179 10.4705 4.82224 10.7495 4.66116L11.7598 4.07783C12.0388 3.91674 12.3956 4.01234 12.5567 4.29134Z"
      fill="#50565E"
    />
    <path
      d="M11.6663 6.91634C11.3442 6.91634 11.083 7.17751 11.083 7.49967C11.083 7.82184 11.3442 8.08301 11.6663 8.08301H12.833C13.1552 8.08301 13.4163 7.82184 13.4163 7.49967C13.4163 7.17751 13.1552 6.91634 12.833 6.91634H11.6663Z"
      fill="#50565E"
    />
    <path
      d="M10.536 9.54134C10.697 9.26234 11.0538 9.16674 11.3328 9.32783L12.3432 9.91116C12.6222 10.0722 12.7178 10.429 12.5567 10.708C12.3956 10.987 12.0388 11.0826 11.7598 10.9215L10.7495 10.3382C10.4705 10.1771 10.3749 9.82034 10.536 9.54134Z"
      fill="#50565E"
    />
    <path
      d="M9.83819 11.2495C9.67711 10.9705 9.32034 10.8749 9.04134 11.036C8.76234 11.197 8.66674 11.5538 8.82783 11.8328L9.41116 12.8432C9.57224 13.1222 9.929 13.2178 10.208 13.0567C10.487 12.8956 10.5826 12.5388 10.4215 12.2598L9.83819 11.2495Z"
      fill="#50565E"
    />
    <path
      d="M6.99967 11.583C7.32184 11.583 7.58301 11.8442 7.58301 12.1663V13.333C7.58301 13.6552 7.32184 13.9163 6.99967 13.9163C6.67751 13.9163 6.41634 13.6552 6.41634 13.333V12.1663C6.41634 11.8442 6.67751 11.583 6.99967 11.583Z"
      fill="#50565E"
    />
    <path
      d="M5.17152 11.8328C5.33261 11.5538 5.23701 11.197 4.95801 11.036C4.679 10.8749 4.32224 10.9705 4.16116 11.2495L3.57783 12.2598C3.41674 12.5388 3.51234 12.8956 3.79134 13.0567C4.07034 13.2178 4.42711 13.1222 4.58819 12.8432L5.17152 11.8328Z"
      fill="#50565E"
    />
    <path
      d="M3.46338 9.54134C3.62446 9.82034 3.52887 10.1771 3.24987 10.3382L2.23951 10.9215C1.96051 11.0826 1.60375 10.987 1.44267 10.708C1.28158 10.429 1.37717 10.0722 1.65618 9.91116L2.66653 9.32783C2.94553 9.16674 3.30229 9.26233 3.46338 9.54134Z"
      fill="#50565E"
    />
    <path
      d="M1.16634 6.91634C0.844175 6.91634 0.583008 7.17751 0.583008 7.49967C0.583008 7.82184 0.844175 8.08301 1.16634 8.08301H2.33301C2.65517 8.08301 2.91634 7.82184 2.91634 7.49967C2.91634 7.17751 2.65517 6.91634 2.33301 6.91634H1.16634Z"
      fill="#50565E"
    />
    <path
      d="M1.44267 4.29134C1.60375 4.01234 1.96051 3.91674 2.23951 4.07783L3.24987 4.66116C3.52887 4.82225 3.62446 5.17901 3.46338 5.45801C3.30229 5.73701 2.94553 5.83261 2.66653 5.67152L1.65618 5.08819C1.37717 4.9271 1.28158 4.57034 1.44267 4.29134Z"
      fill="#50565E"
    />
    <path
      d="M4.58819 2.15625C4.4271 1.87724 4.07034 1.78165 3.79134 1.94274C3.51234 2.10382 3.41674 2.46058 3.57783 2.73959L4.16116 3.74994C4.32225 4.02894 4.67901 4.12453 4.95801 3.96345C5.23701 3.80236 5.33261 3.4456 5.17152 3.1666L4.58819 2.15625Z"
      fill="#50565E"
    />
  </svg>
)

export const DeleteLoadIcon = ({ onClick, height, width }) => (
  <svg
    fill="none"
    height={height || '15'}
    onClick={onClick}
    viewBox="0 0 14 15"
    width={width || '14'}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.8335 5.75016C6.15566 5.75016 6.41683 6.01133 6.41683 6.3335V10.1252C6.41683 10.4473 6.15566 10.7085 5.8335 10.7085C5.51133 10.7085 5.25016 10.4473 5.25016 10.1252V6.3335C5.25016 6.01133 5.51133 5.75016 5.8335 5.75016Z"
      fill="#FF212C"
    />
    <path
      d="M8.75016 6.3335C8.75016 6.01133 8.489 5.75016 8.16683 5.75016C7.84466 5.75016 7.5835 6.01133 7.5835 6.3335V10.1252C7.5835 10.4473 7.84466 10.7085 8.16683 10.7085C8.489 10.7085 8.75016 10.4473 8.75016 10.1252V6.3335Z"
      fill="#FF212C"
    />
    <path
      clipRule="evenodd"
      d="M5.62612 1.0835C5.41309 1.0835 5.217 1.19962 5.1146 1.38643L4.32137 2.8335H1.16683C0.844663 2.8335 0.583496 3.09466 0.583496 3.41683C0.583496 3.739 0.844663 4.00016 1.16683 4.00016H2.04183V13.3335C2.04183 13.6557 2.303 13.9168 2.62516 13.9168H11.3752C11.6973 13.9168 11.9585 13.6557 11.9585 13.3335V4.00016H12.8335C13.1557 4.00016 13.4168 3.739 13.4168 3.41683C13.4168 3.09466 13.1557 2.8335 12.8335 2.8335H9.68232L8.90737 1.39079C8.80572 1.20156 8.60829 1.0835 8.39348 1.0835H5.62612ZM8.358 2.8335L8.04466 2.25016H5.97158L5.65182 2.8335H8.358ZM3.2085 4.00016V12.7502H10.7918V4.00016H3.2085Z"
      fill="#FF212C"
      fillRule="evenodd"
    />
  </svg>
)

export const InfoIcon = ({ className }) => (
  <svg
    className={className}
    fill="none"
    height="14"
    viewBox="0 0 14 14"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.72933 3.93742C7.72933 3.53471 7.40287 3.20825 7.00016 3.20825C6.59746 3.20825 6.271 3.53471 6.271 3.93742C6.271 4.34012 6.59746 4.66658 7.00016 4.66658C7.40287 4.66658 7.72933 4.34012 7.72933 3.93742Z"
      fill="#888E96"
    />
    <path
      d="M5.97933 5.83325C5.97933 5.51109 6.2405 5.24992 6.56266 5.24992H7.146C7.46816 5.24992 7.72933 5.51109 7.72933 5.83325V9.33325H8.16683C8.489 9.33325 8.75016 9.59442 8.75016 9.91658C8.75016 10.2388 8.489 10.4999 8.16683 10.4999H6.12516C5.803 10.4999 5.54183 10.2388 5.54183 9.91658C5.54183 9.59442 5.803 9.33325 6.12516 9.33325H6.56266V6.41658C6.2405 6.41658 5.97933 6.15542 5.97933 5.83325Z"
      fill="#888E96"
    />
    <path
      clipRule="evenodd"
      d="M7.00016 0.583252C5.22842 0.583252 3.62346 1.3021 2.4629 2.46265C1.30235 3.62321 0.583496 5.22818 0.583496 6.99992C0.583496 8.77166 1.30235 10.3766 2.46289 11.5372C3.62345 12.6977 5.22842 13.4166 7.00016 13.4166C8.7719 13.4166 10.3769 12.6977 11.5374 11.5372C12.698 10.3766 13.4168 8.77166 13.4168 6.99992C13.4168 5.22818 12.698 3.62321 11.5374 2.46265C10.3769 1.30211 8.7719 0.583252 7.00016 0.583252ZM3.28785 3.28761C4.23857 2.33691 5.55027 1.74992 7.00016 1.74992C8.45006 1.74992 9.76176 2.33691 10.7125 3.28761C11.6632 4.23832 12.2502 5.55003 12.2502 6.99992C12.2502 8.44981 11.6632 9.76151 10.7125 10.7122C9.76176 11.6629 8.45006 12.2499 7.00016 12.2499C5.55027 12.2499 4.23857 11.6629 3.28785 10.7122C2.33715 9.76151 1.75016 8.44981 1.75016 6.99992C1.75016 5.55003 2.33714 4.23833 3.28785 3.28761Z"
      fill="#888E96"
      fillRule="evenodd"
    />
  </svg>
)

export const IconDownAddLoad = ({ className }) => (
  <svg
    className={className}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M5.79289 8.29289C6.18342 7.90237 6.81658 7.90237 7.20711 8.29289L12.5 13.5858L17.7929 8.29289C18.1834 7.90237 18.8166 7.90237 19.2071 8.29289C19.5976 8.68342 19.5976 9.31658 19.2071 9.70711L13.2071 15.7071C12.8166 16.0976 12.1834 16.0976 11.7929 15.7071L5.79289 9.70711C5.40237 9.31658 5.40237 8.68342 5.79289 8.29289Z"
      fill="#50565E"
      fillRule="evenodd"
    />
  </svg>
)

export const IconRightAddLoad = ({ className, onClick }) => (
  <svg
    className={className}
    fill="none"
    height="24"
    onClick={onClick}
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M8.79289 5.29289C9.18342 4.90237 9.81658 4.90237 10.2071 5.29289L16.2071 11.2929C16.5976 11.6834 16.5976 12.3166 16.2071 12.7071L10.2071 18.7071C9.81658 19.0976 9.18342 19.0976 8.79289 18.7071C8.40237 18.3166 8.40237 17.6834 8.79289 17.2929L14.0858 12L8.79289 6.70711C8.40237 6.31658 8.40237 5.68342 8.79289 5.29289Z"
      fill="#50565E"
      fillRule="evenodd"
    />
  </svg>
)

export const IconHambergerAddLoad = ({ className }) => (
  <svg
    className={className}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M4 9H20V11H4V9ZM20 15H4V13H20V15Z"
      fill="#50565E"
      fillRule="evenodd"
    />
  </svg>
)

export const IconTargetAddLoad = () => (
  <svg
    fill="none"
    height="18"
    viewBox="0 0 18 18"
    width="18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M9.28125 3.375C6.17625 3.375 3.65625 5.895 3.65625 9C3.65625 12.105 6.17625 14.625 9.28125 14.625C12.3862 14.625 14.9062 12.105 14.9062 9C14.9062 5.895 12.3862 3.375 9.28125 3.375ZM8.71875 6.1875V8.4375H6.46875V9.5625H8.71875V11.8125H9.84375V9.5625H12.0938V8.4375H9.84375V6.1875H8.71875ZM4.78125 9C4.78125 11.4806 6.80063 13.5 9.28125 13.5C11.7619 13.5 13.7812 11.4806 13.7812 9C13.7812 6.51938 11.7619 4.5 9.28125 4.5C6.80063 4.5 4.78125 6.51938 4.78125 9Z"
      fill="#50565E"
      fillRule="evenodd"
    />
  </svg>
)

export const IconMinusAddLoad = ({ className }) => (
  <svg
    className={className}
    fill="none"
    height="18"
    viewBox="0 0 18 18"
    width="18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M9.28125 3.375C6.17625 3.375 3.65625 5.895 3.65625 9C3.65625 12.105 6.17625 14.625 9.28125 14.625C12.3862 14.625 14.9062 12.105 14.9062 9C14.9062 5.895 12.3862 3.375 9.28125 3.375ZM4.78125 9C4.78125 11.4806 6.80063 13.5 9.28125 13.5C11.7619 13.5 13.7812 11.4806 13.7812 9C13.7812 6.51938 11.7619 4.5 9.28125 4.5C6.80063 4.5 4.78125 6.51938 4.78125 9ZM6.46875 8.4375V9.5625H12.0938V8.4375H6.46875Z"
      fill="#50565E"
      fillRule="evenodd"
    />
  </svg>
)

export const IconDeleteAddLoad = ({ className }) => (
  <svg
    className={className}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.875 9.75C11.2892 9.75 11.625 10.0858 11.625 10.5V15.375C11.625 15.7892 11.2892 16.125 10.875 16.125C10.4608 16.125 10.125 15.7892 10.125 15.375V10.5C10.125 10.0858 10.4608 9.75 10.875 9.75Z"
      fill="#FF212C"
    />
    <path
      d="M14.625 10.5C14.625 10.0858 14.2892 9.75 13.875 9.75C13.4608 9.75 13.125 10.0858 13.125 10.5V15.375C13.125 15.7892 13.4608 16.125 13.875 16.125C14.2892 16.125 14.625 15.7892 14.625 15.375V10.5Z"
      fill="#FF212C"
    />
    <path
      clipRule="evenodd"
      d="M10.6084 3.75C10.3345 3.75 10.0824 3.89931 9.9507 4.13949L8.93083 6H4.875C4.46079 6 4.125 6.33579 4.125 6.75C4.125 7.16421 4.46079 7.5 4.875 7.5H6V19.5C6 19.9142 6.33579 20.25 6.75 20.25H18C18.4142 20.25 18.75 19.9142 18.75 19.5V7.5H19.875C20.2892 7.5 20.625 7.16421 20.625 6.75C20.625 6.33579 20.2892 6 19.875 6H15.8235L14.8271 4.1451C14.6964 3.90179 14.4426 3.75 14.1664 3.75H10.6084ZM14.1208 6L13.7179 5.25H11.0525L10.6414 6H14.1208ZM7.5 7.5V18.75H17.25V7.5H7.5Z"
      fill="#FF212C"
      fillRule="evenodd"
    />
  </svg>
)
export const IconSearchLoad = () => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M4.125 10.875C4.125 6.93999 7.31499 3.75 11.25 3.75C15.185 3.75 18.375 6.93999 18.375 10.875C18.375 12.5724 17.7815 14.1311 16.7906 15.355L19.5455 18.1098C19.8384 18.4027 19.8384 18.8776 19.5455 19.1705C19.2526 19.4634 18.7777 19.4634 18.4848 19.1705L15.73 16.4156C14.5061 17.4065 12.9474 18 11.25 18C7.31499 18 4.125 14.81 4.125 10.875ZM11.25 5.25C8.14341 5.25 5.625 7.76841 5.625 10.875C5.625 13.9816 8.14341 16.5 11.25 16.5C14.3566 16.5 16.875 13.9816 16.875 10.875C16.875 7.76841 14.3566 5.25 11.25 5.25ZM8.59835 7.84831C9.27617 7.17054 10.2147 6.75 11.25 6.75C12.2853 6.75 13.2238 7.17054 13.9016 7.84833C14.1945 8.14123 14.1945 8.6161 13.9016 8.90899C13.6087 9.20189 13.1339 9.20189 12.841 8.90899C12.433 8.50101 11.8715 8.25 11.25 8.25C10.6285 8.25 10.067 8.50101 9.65897 8.90901C9.36607 9.20189 8.8912 9.20188 8.59831 8.90897C8.30543 8.61607 8.30545 8.1412 8.59835 7.84831Z"
      fill="#50565E"
      fillRule="evenodd"
    />
  </svg>
)

export const ArrowSelect = () => (
  <svg
    fill="none"
    height="18"
    viewBox="0 0 18 18"
    width="18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M4.71967 6.21967C5.01256 5.92678 5.48744 5.92678 5.78033 6.21967L9.75 10.1893L13.7197 6.21967C14.0126 5.92678 14.4874 5.92678 14.7803 6.21967C15.0732 6.51256 15.0732 6.98744 14.7803 7.28033L10.2803 11.7803C9.98744 12.0732 9.51256 12.0732 9.21967 11.7803L4.71967 7.28033C4.42678 6.98744 4.42678 6.51256 4.71967 6.21967Z"
      fill="#50565E"
      fillRule="evenodd"
    />
  </svg>
)

export const IconNotiSuccess = ({ className }) => (
  <svg
    className={className}
    fill="none"
    height="14"
    viewBox="0 0 14 14"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M2.46277 2.96274C3.62334 1.80219 5.2283 1.08334 7.00004 1.08334C8.77178 1.08334 10.3767 1.80219 11.5373 2.96274L11.1248 3.37522L11.5373 2.96274C12.6979 4.1233 13.4167 5.72827 13.4167 7.50001C13.4167 9.27175 12.6979 10.8767 11.5373 12.0373C10.3767 13.1978 8.77178 13.9167 7.00004 13.9167C5.2283 13.9167 3.62333 13.1978 2.46277 12.0373L2.87525 11.6248L2.46277 12.0373C1.30222 10.8767 0.583374 9.27175 0.583374 7.50001C0.583374 5.72827 1.30222 4.12331 2.46277 2.96274L2.46277 2.96274ZM7.00004 2.25001C5.55015 2.25001 4.23844 2.837 3.28773 3.7877C2.33702 4.73842 1.75004 6.05012 1.75004 7.50001C1.75004 8.9499 2.33703 10.2616 3.28773 11.2123C4.23845 12.163 5.55015 12.75 7.00004 12.75C8.44993 12.75 9.76163 12.163 10.7123 11.2123C11.663 10.2616 12.25 8.9499 12.25 7.50001C12.25 6.05012 11.663 4.73842 10.7123 3.7877C9.76164 2.837 8.44993 2.25001 7.00004 2.25001ZM10.3292 5.33753C10.557 5.56534 10.557 5.93468 10.3292 6.16249L6.82919 9.66249C6.60138 9.8903 6.23203 9.8903 6.00423 9.66249L4.25423 7.91249C4.02642 7.68468 4.02642 7.31534 4.25423 7.08753C4.48203 6.85972 4.85138 6.85972 5.07919 7.08753L6.41671 8.42505L9.50423 5.33753C9.73203 5.10973 10.1014 5.10973 10.3292 5.33753Z"
      fill="white"
      fillRule="evenodd"
    />
  </svg>
)

export const IconNotiFailed = ({ className }) => (
  <svg
    className={className}
    fill="none"
    height="14"
    viewBox="0 0 14 14"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M0.583374 7.50001C0.583374 3.95618 3.45621 1.08334 7.00004 1.08334C10.5439 1.08334 13.4167 3.95618 13.4167 7.50001C13.4167 11.0438 10.5439 13.9167 7.00004 13.9167C3.45621 13.9167 0.583374 11.0438 0.583374 7.50001ZM7.00004 2.25001C4.10054 2.25001 1.75004 4.60051 1.75004 7.50001C1.75004 10.3995 4.10054 12.75 7.00004 12.75C9.89954 12.75 12.25 10.3995 12.25 7.50001C12.25 4.60051 9.89954 2.25001 7.00004 2.25001ZM4.93766 5.4376C5.16547 5.2098 5.53481 5.2098 5.76262 5.4376L7.00005 6.67504L8.23749 5.4376C8.4653 5.2098 8.83464 5.2098 9.06245 5.4376C9.29025 5.66541 9.29025 6.03475 9.06245 6.26256L7.82501 7.5L9.06245 8.73743C9.29025 8.96524 9.29025 9.33458 9.06245 9.56239C8.83464 9.79019 8.4653 9.79019 8.23749 9.56239L7.00005 8.32495L5.76262 9.56239C5.53481 9.79019 5.16547 9.79019 4.93766 9.56239C4.70986 9.33458 4.70986 8.96524 4.93766 8.73743L6.1751 7.5L4.93766 6.26256C4.70986 6.03475 4.70986 5.66541 4.93766 5.4376Z"
      fill="white"
      fillRule="evenodd"
    />
  </svg>
)

export const IconPrevPagination = () => (
  <svg
    fill="none"
    height="18"
    viewBox="0 0 18 18"
    width="18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M12.1553 3.96967C12.4482 4.26256 12.4482 4.73744 12.1553 5.03033L8.18566 9L12.1553 12.9697C12.4482 13.2626 12.4482 13.7374 12.1553 14.0303C11.8624 14.3232 11.3876 14.3232 11.0947 14.0303L6.59467 9.53033C6.30178 9.23744 6.30178 8.76256 6.59467 8.46967L11.0947 3.96967C11.3876 3.67678 11.8624 3.67678 12.1553 3.96967Z"
      fill="#50565E"
      fillRule="evenodd"
    />
  </svg>
)

export const IconNextPagination = () => (
  <svg
    fill="none"
    height="18"
    viewBox="0 0 18 18"
    width="18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M6.59467 3.96967C6.88756 3.67678 7.36244 3.67678 7.65533 3.96967L12.1553 8.46967C12.4482 8.76256 12.4482 9.23744 12.1553 9.53033L7.65533 14.0303C7.36244 14.3232 6.88756 14.3232 6.59467 14.0303C6.30178 13.7374 6.30178 13.2626 6.59467 12.9697L10.5643 9L6.59467 5.03033C6.30178 4.73744 6.30178 4.26256 6.59467 3.96967Z"
      fill="#50565E"
      fillRule="evenodd"
    />
  </svg>
)

export const IconEdit2 = () => (
  <svg
    fill="none"
    height="15"
    viewBox="0 0 14 15"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M1.16699 2.83366C1.16699 2.18933 1.68933 1.66699 2.33366 1.66699H6.41699C6.73916 1.66699 7.00033 1.92816 7.00033 2.25033C7.00033 2.57249 6.73916 2.83366 6.41699 2.83366H2.33366V12.167H11.667V8.08366C11.667 7.76149 11.9282 7.50033 12.2503 7.50033C12.5725 7.50033 12.8337 7.76149 12.8337 8.08366V12.167C12.8337 12.8113 12.3113 13.3337 11.667 13.3337H2.33366C1.68933 13.3337 1.16699 12.8113 1.16699 12.167V2.83366ZM10.1196 1.66699C10.2744 1.66696 10.4229 1.72846 10.5323 1.83794L12.6629 3.96947C12.8906 4.19725 12.8906 4.56646 12.6629 4.79424L6.63041 10.8294C6.52101 10.9388 6.3726 11.0003 6.21784 11.0003H4.08366C3.76149 11.0003 3.50033 10.7392 3.50033 10.417V8.29363C3.50033 8.13904 3.56169 7.99077 3.67093 7.8814L9.707 1.83809C9.81639 1.72857 9.96483 1.66702 10.1196 1.66699ZM10.1199 3.07562L4.66699 8.53505V9.83366H5.97614L11.4255 4.38186L10.1199 3.07562Z"
      fill="#50565E"
      fillRule="evenodd"
    />
  </svg>
)

export const EditLoadIcon = ({ height, width }) => (
  <svg
    fill="none"
    height={height || '15'}
    viewBox="0 0 14 15"
    width={width || '14'}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M1.1665 2.83317C1.1665 2.18884 1.68884 1.6665 2.33317 1.6665H6.4165C6.73867 1.6665 6.99984 1.92767 6.99984 2.24984C6.99984 2.572 6.73867 2.83317 6.4165 2.83317H2.33317V12.1665H11.6665V8.08317C11.6665 7.761 11.9277 7.49984 12.2498 7.49984C12.572 7.49984 12.8332 7.761 12.8332 8.08317V12.1665C12.8332 12.8108 12.3108 13.3332 11.6665 13.3332H2.33317C1.68884 13.3332 1.1665 12.8109 1.1665 12.1665V2.83317ZM10.1191 1.6665C10.2739 1.66647 10.4224 1.72797 10.5318 1.83745L12.6624 3.96898C12.8901 4.19676 12.8901 4.56597 12.6624 4.79375L6.62992 10.8289C6.52052 10.9383 6.37211 10.9998 6.21735 10.9998H4.08317C3.761 10.9998 3.49984 10.7387 3.49984 10.4165V8.29314C3.49984 8.13855 3.5612 7.99029 3.67044 7.88091L9.70652 1.83761C9.8159 1.72809 9.96434 1.66653 10.1191 1.6665ZM10.1194 3.07513L4.6665 8.53456V9.83317H5.97565L11.4251 4.38137L10.1194 3.07513Z"
      fill="#50565E"
      fillRule="evenodd"
    />
  </svg>
)

export const IconTrackingFailed = () => (
  <svg
    fill="none"
    height="18"
    viewBox="0 0 18 18"
    width="18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M12.6172 7.3125C12.6172 5.76 11.3572 4.5 9.80469 4.5C9.08469 4.5 8.43219 4.78125 7.93719 5.22562L7.13281 4.42125C7.83594 3.77437 8.76969 3.375 9.80469 3.375C11.9816 3.375 13.7422 5.13562 13.7422 7.3125C13.7422 8.19562 13.3878 9.2025 12.8928 10.1869L12.0547 9.34875C12.3978 8.6175 12.6172 7.90875 12.6172 7.3125ZM8.92719 6.22125C9.16906 6.02438 9.47281 5.90625 9.80469 5.90625C10.5809 5.90625 11.2109 6.53625 11.2109 7.3125C11.2109 7.64438 11.0928 7.94813 10.8959 8.19L8.92719 6.22125ZM4.97281 3.85875L4.17969 4.65187L5.96844 6.44062C5.90656 6.72187 5.86719 7.01437 5.86719 7.3125C5.86719 10.2656 9.80469 14.625 9.80469 14.625C9.80469 14.625 10.7441 13.5844 11.7059 12.1781L13.5903 14.0625L14.3834 13.2694L4.97281 3.85875ZM7.00344 7.47563C7.10469 9.07875 8.67406 11.4187 9.80469 12.87C10.1478 12.4312 10.5303 11.9194 10.8959 11.3681L7.00344 7.47563Z"
      fill="#FF212C"
      fillRule="evenodd"
    />
  </svg>
)

export const IconRequestDocument = ({ className }) => (
  <svg
    className={className}
    fill="none"
    height="18"
    viewBox="0 0 18 18"
    width="18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.25 2.25C2.25 1.42157 2.92157 0.75 3.75 0.75H14.25C15.0784 0.75 15.75 1.42158 15.75 2.25V10.125C15.75 10.5392 15.4142 10.875 15 10.875C14.5858 10.875 14.25 10.5392 14.25 10.125V2.25H3.75V15.75H7.875C8.28921 15.75 8.625 16.0858 8.625 16.5C8.625 16.9142 8.28921 17.25 7.875 17.25H3.75C2.92158 17.25 2.25 16.5784 2.25 15.75V2.25Z"
      fill="white"
    />
    <path
      d="M5.625 4.5C5.625 4.08579 5.96079 3.75 6.375 3.75H11.625C12.0392 3.75 12.375 4.08579 12.375 4.5C12.375 4.91421 12.0392 5.25 11.625 5.25H6.375C5.96079 5.25 5.625 4.91421 5.625 4.5Z"
      fill="white"
    />
    <path
      d="M6.375 6.75C5.96079 6.75 5.625 7.08579 5.625 7.5C5.625 7.91421 5.96079 8.25 6.375 8.25H11.625C12.0392 8.25 12.375 7.91421 12.375 7.5C12.375 7.08579 12.0392 6.75 11.625 6.75H6.375Z"
      fill="white"
    />
    <path
      d="M5.625 10.5C5.625 10.0858 5.96079 9.75 6.375 9.75H8.625C9.03921 9.75 9.375 10.0858 9.375 10.5C9.375 10.9142 9.03921 11.25 8.625 11.25H6.375C5.96079 11.25 5.625 10.9142 5.625 10.5Z"
      fill="white"
    />
    <path
      clipRule="evenodd"
      d="M12 11.25C10.5503 11.25 9.375 12.4253 9.375 13.875C9.375 15.3247 10.5503 16.5 12 16.5C12.4518 16.5 12.8773 16.3855 13.2487 16.1844L14.0947 17.0303C14.3876 17.3232 14.8624 17.3232 15.1553 17.0303C15.4482 16.7374 15.4482 16.2626 15.1553 15.9697L14.3094 15.1237C14.5105 14.7523 14.625 14.3268 14.625 13.875C14.625 12.4253 13.4497 11.25 12 11.25ZM13.125 13.875C13.125 14.1859 12.9999 14.4661 12.7955 14.6705C12.5911 14.8749 12.3109 15 12 15C11.3787 15 10.875 14.4963 10.875 13.875C10.875 13.2537 11.3787 12.75 12 12.75C12.6213 12.75 13.125 13.2537 13.125 13.875Z"
      fill="white"
      fillRule="evenodd"
    />
  </svg>
)

export const IconUploadDocument = ({ className }) => (
  <svg
    className={className}
    fill="none"
    height="18"
    viewBox="0 0 18 18"
    width="18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M1.35636 5.25033C2.55819 2.94476 5.05711 1.6189 7.64007 1.9164C10.0262 2.19123 12.0277 3.79899 12.8282 6.02796H13.1446C14.8917 6.02682 16.6378 6.95018 17.2155 8.7735C17.7693 10.5217 17.1261 12.4272 15.626 13.4821C15.2872 13.7203 14.8194 13.6388 14.5811 13.3C14.3428 12.9611 14.4244 12.4933 14.7632 12.2551C15.728 11.5766 16.1418 10.351 15.7855 9.22654C15.4531 8.17742 14.4119 7.52698 13.1458 7.52796L12.2748 7.52796C11.9324 7.52796 11.6335 7.29604 11.5484 6.96437C11.0566 5.04786 9.43405 3.63294 7.46844 3.40655C5.50279 3.18015 3.60109 4.18914 2.6865 5.94369C1.7719 7.69824 2.03379 9.83505 3.34503 11.3168C3.61953 11.627 3.59059 12.101 3.2804 12.3755C2.9702 12.65 2.49621 12.6211 2.22171 12.3109C0.498675 10.3638 0.154536 7.5559 1.35636 5.25033ZM8.47004 7.44673C8.76293 7.15384 9.2378 7.15384 9.53069 7.44673L11.9172 9.83319C12.2101 10.1261 12.2101 10.601 11.9172 10.8938C11.6243 11.1867 11.1494 11.1867 10.8565 10.8939L9.75087 9.78821L9.75348 15.3747C9.75367 15.7889 9.41804 16.1248 9.00383 16.125C8.58961 16.1252 8.25367 15.7896 8.25348 15.3754L8.25087 9.7872L7.14419 10.8939C6.85129 11.1867 6.37642 11.1867 6.08353 10.8938C5.79064 10.601 5.79064 10.1261 6.08354 9.83319L8.47004 7.44673Z"
      fill="white"
      fillRule="evenodd"
    />
  </svg>
)

export const IconSharp = ({ style }) => (
  <svg
    fill="none"
    height="15"
    style={style}
    viewBox="0 0 14 15"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M4.66699 1.66666C4.98916 1.66666 5.25033 1.92782 5.25033 2.24999V4.58332H8.75033V2.24999C8.75033 1.92782 9.01149 1.66666 9.33366 1.66666C9.65583 1.66666 9.91699 1.92782 9.91699 2.24999V4.58332H12.2503C12.5725 4.58332 12.8337 4.84449 12.8337 5.16666C12.8337 5.48882 12.5725 5.74999 12.2503 5.74999H9.91699V9.24999H12.2503C12.5725 9.24999 12.8337 9.51116 12.8337 9.83332C12.8337 10.1555 12.5725 10.4167 12.2503 10.4167H9.91699V12.75C9.91699 13.0722 9.65583 13.3333 9.33366 13.3333C9.01149 13.3333 8.75033 13.0722 8.75033 12.75V10.4167H5.25033V12.75C5.25033 13.0722 4.98916 13.3333 4.66699 13.3333C4.34483 13.3333 4.08366 13.0722 4.08366 12.75V10.4167H1.75033C1.42816 10.4167 1.16699 10.1555 1.16699 9.83332C1.16699 9.51116 1.42816 9.24999 1.75033 9.24999H4.08366V5.74999H1.75033C1.42816 5.74999 1.16699 5.48882 1.16699 5.16666C1.16699 4.84449 1.42816 4.58332 1.75033 4.58332H4.08366V2.24999C4.08366 1.92782 4.34483 1.66666 4.66699 1.66666ZM5.25033 5.74999V9.24999H8.75033V5.74999H5.25033Z"
      fill="#50565E"
      fillRule="evenodd"
    />
  </svg>
)

export const IconResetFile = ({ className, onClick }) => (
  <svg
    className={className}
    fill="none"
    height="24"
    onClick={onClick}
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M8.09467 7.71967C8.38756 7.42678 8.86244 7.42678 9.15533 7.71967L12.375 10.9393L15.5947 7.71967C15.8876 7.42678 16.3624 7.42678 16.6553 7.71967C16.9482 8.01256 16.9482 8.48744 16.6553 8.78033L13.4357 12L16.6553 15.2197C16.9482 15.5126 16.9482 15.9874 16.6553 16.2803C16.3624 16.5732 15.8876 16.5732 15.5947 16.2803L12.375 13.0607L9.15533 16.2803C8.86244 16.5732 8.38756 16.5732 8.09467 16.2803C7.80178 15.9874 7.80178 15.5126 8.09467 15.2197L11.3143 12L8.09467 8.78033C7.80178 8.48744 7.80178 8.01256 8.09467 7.71967Z"
      fill="#50565E"
      fillRule="evenodd"
    />
  </svg>
)

export const IconDownload32 = ({ className, onClick }) => (
  <svg
    className={className}
    fill="none"
    height="32"
    onClick={onClick}
    viewBox="0 0 32 32"
    width="32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.30718 11.0004C7.90962 7.92635 11.2415 6.15854 14.6855 6.5552C17.867 6.92164 20.5356 9.06532 21.603 12.0373H22.0249C24.3543 12.0358 26.6824 13.2669 27.4526 15.698C28.1911 18.0289 27.3335 20.5696 25.3334 21.9761C24.8816 22.2938 24.2579 22.1851 23.9402 21.7333C23.6225 21.2815 23.7312 20.6578 24.183 20.3401C25.4694 19.4355 26.021 17.8013 25.546 16.3021C25.1028 14.9032 23.7145 14.036 22.0264 14.0373L20.8651 14.0373C20.4086 14.0373 20.01 13.7281 19.8965 13.2858C19.2408 10.7305 17.0774 8.84392 14.4566 8.54206C11.8357 8.2402 9.30016 9.58551 8.08069 11.9249C6.86123 14.2643 7.21042 17.1134 8.95874 19.0891C9.32474 19.5027 9.28616 20.1347 8.87256 20.5007C8.45897 20.8667 7.82698 20.8281 7.46098 20.4145C5.1636 17.8184 4.70475 14.0745 6.30718 11.0004Z"
      fill="#50565E"
    />
    <path
      d="M16.4989 14.5C17.0512 14.4998 17.4991 14.9473 17.4994 15.4996L17.5024 22.0829L18.9741 20.6113C19.3646 20.2208 19.9978 20.2208 20.3883 20.6113C20.7788 21.0018 20.7788 21.635 20.3883 22.0255L17.2622 25.1516C17.0935 25.3478 16.85 25.4779 16.5759 25.4975C16.295 25.5189 16.0069 25.4223 15.7921 25.2075L12.6101 22.0255C12.2196 21.635 12.2196 21.0018 12.6101 20.6113C13.0006 20.2208 13.6338 20.2208 14.0243 20.6113L15.5024 22.0894L15.4994 15.5005C15.4991 14.9482 15.9466 14.5003 16.4989 14.5Z"
      fill="#50565E"
    />
  </svg>
)

export const IconArchive32 = ({ className, onClick }) => (
  <svg
    className={className}
    fill="none"
    height="32"
    onClick={onClick}
    viewBox="0 0 32 32"
    width="32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M8 7C7.72386 7 7.5 7.22386 7.5 7.5V20H12C12.3788 20 12.725 20.214 12.8944 20.5528L13.618 22H19.382L20.1056 20.5528C20.275 20.214 20.6212 20 21 20H25.5V7.5C25.5 7.22386 25.2761 7 25 7H8ZM27.5 7.5C27.5 6.11929 26.3807 5 25 5H8C6.61929 5 5.5 6.11929 5.5 7.5V24.5C5.5 25.8807 6.61929 27 8 27H25C26.3807 27 27.5 25.8807 27.5 24.5V7.5ZM25.5 22H21.618L20.8944 23.4472C20.725 23.786 20.3788 24 20 24H13C12.6212 24 12.275 23.786 12.1056 23.4472L11.382 22H7.5V24.5C7.5 24.7761 7.72386 25 8 25H25C25.2761 25 25.5 24.7761 25.5 24.5V22ZM16.5 9C17.0523 9 17.5 9.44772 17.5 10V16.5858L19.7929 14.2929C20.1834 13.9024 20.8166 13.9024 21.2071 14.2929C21.5976 14.6834 21.5976 15.3166 21.2071 15.7071L17.2071 19.7071C16.8166 20.0976 16.1834 20.0976 15.7929 19.7071L11.7929 15.7071C11.4024 15.3166 11.4024 14.6834 11.7929 14.2929C12.1834 13.9024 12.8166 13.9024 13.2071 14.2929L15.5 16.5858V10C15.5 9.44772 15.9477 9 16.5 9Z"
      fill="#50565E"
      fillRule="evenodd"
    />
  </svg>
)

export const IconUnarchive32 = ({ className, onClick }) => (
  <svg
    className={className}
    onClick={onClick}
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.7929 9.29289C16.1834 8.90237 16.8166 8.90237 17.2071 9.29289L21.2071 13.2929C21.5976 13.6834 21.5976 14.3166 21.2071 14.7071C20.8166 15.0976 20.1834 15.0976 19.7929 14.7071L17.5 12.4142V19C17.5 19.5523 17.0523 20 16.5 20C15.9477 20 15.5 19.5523 15.5 19V12.4142L13.2071 14.7071C12.8166 15.0976 12.1834 15.0976 11.7929 14.7071C11.4024 14.3166 11.4024 13.6834 11.7929 13.2929L15.7929 9.29289Z"
      fill="#50565E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 7.5C5.5 6.11929 6.61929 5 8 5H25C26.3807 5 27.5 6.11929 27.5 7.5V24.5C27.5 25.8807 26.3807 27 25 27H8C6.61929 27 5.5 25.8807 5.5 24.5V7.5ZM7.5 7.5C7.5 7.22386 7.72386 7 8 7H25C25.2761 7 25.5 7.22386 25.5 7.5V20H21C20.6212 20 20.275 20.214 20.1056 20.5528L19.382 22H13.618L12.8944 20.5528C12.725 20.214 12.3788 20 12 20H7.5V7.5ZM7.5 24.5C7.5 24.7761 7.72386 25 8 25H25C25.2761 25 25.5 24.7761 25.5 24.5V22H21.618L20.8944 23.4472C20.725 23.786 20.3788 24 20 24H13C12.6212 24 12.275 23.786 12.1056 23.4472L11.382 22H7.5V24.5Z"
      fill="#50565E"
    />
  </svg>
)

export const IconSend32 = ({ className, onClick }) => (
  <svg
    className={className}
    fill="none"
    height="32"
    onClick={onClick}
    viewBox="0 0 32 32"
    width="32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M26.7071 5.79292C26.9788 6.06456 27.0708 6.46779 26.9439 6.83038L20.2939 25.8304C20.1584 26.2174 19.8004 26.4825 19.3908 26.4992C18.9811 26.5159 18.6027 26.2808 18.4362 25.9062L14.7924 17.7076L6.59387 14.0638C6.21919 13.8973 5.98412 13.5189 6.00084 13.1093C6.01755 12.6996 6.28265 12.3416 6.66965 12.2062L25.6697 5.55617C26.0322 5.42926 26.4355 5.52128 26.7071 5.79292ZM16.7428 17.1715L19.2394 22.789L23.6085 10.3057L16.7428 17.1715ZM22.1943 8.8915L9.71108 13.2606L15.3285 15.7573L22.1943 8.8915Z"
      fill="#50565E"
      fillRule="evenodd"
    />
  </svg>
)
export const IconReject32 = ({ className, onClick }) => (
  <svg
    className={className}
    fill="none"
    height="32"
    onClick={onClick}
    viewBox="0 0 32 32"
    width="32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M9 8C8.72386 8 8.5 8.22386 8.5 8.5V23.5C8.5 23.7761 8.72386 24 9 24H14.005C14.5572 24 15.005 24.4477 15.005 25C15.005 25.5523 14.5572 26 14.005 26H9C7.61929 26 6.5 24.8807 6.5 23.5V8.5C6.5 7.11929 7.61929 6 9 6H24C25.3807 6 26.5 7.11929 26.5 8.5V13.5152C26.5 14.0675 26.0523 14.5152 25.5 14.5152C24.9477 14.5152 24.5 14.0675 24.5 13.5152V8.5C24.5 8.22386 24.2761 8 24 8H9ZM16.7071 14.7929C17.0976 15.1834 17.0976 15.8166 16.7071 16.2071L15.3969 17.5173H25.5C26.0523 17.5173 26.5 17.965 26.5 18.5173V24.5C26.5 25.3284 25.8284 26 25 26H19.0185C18.4662 26 18.0185 25.5523 18.0185 25C18.0185 24.4477 18.4662 24 19.0185 24H24.5V19.5173H15.4315L16.7071 20.7929C17.0976 21.1834 17.0976 21.8166 16.7071 22.2071C16.3166 22.5976 15.6834 22.5976 15.2929 22.2071L12.2929 19.2071C11.9024 18.8166 11.9024 18.1834 12.2929 17.7929L15.2929 14.7929C15.6834 14.4024 16.3166 14.4024 16.7071 14.7929Z"
      fill="#50565E"
      fillRule="evenodd"
    />
  </svg>
)
export const IconEdit32 = ({ className, onClick }) => (
  <svg
    className={className}
    fill="none"
    height="32"
    onClick={onClick}
    viewBox="0 0 32 32"
    width="32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M6.5 8C6.5 6.89543 7.39543 6 8.5 6H15.5C16.0523 6 16.5 6.44772 16.5 7C16.5 7.55228 16.0523 8 15.5 8H8.5V24H24.5V17C24.5 16.4477 24.9477 16 25.5 16C26.0523 16 26.5 16.4477 26.5 17V24C26.5 25.1046 25.6046 26 24.5 26H8.5C7.39544 26 6.5 25.1046 6.5 24V8ZM21.8474 6C22.1127 5.99995 22.3672 6.10537 22.5548 6.29305L26.2073 9.9471C26.5976 10.3376 26.5976 10.9705 26.2073 11.361L15.8659 21.707C15.6783 21.8946 15.4239 22 15.1586 22H11.5C10.9477 22 10.5 21.5523 10.5 21V17.36C10.5 17.0949 10.6052 16.8408 10.7925 16.6533L21.14 6.29332C21.3275 6.10557 21.582 6.00005 21.8474 6ZM21.8478 8.41479L12.5 17.7738V20H14.7443L24.0861 10.6541L21.8478 8.41479Z"
      fill="#50565E"
      fillRule="evenodd"
    />
  </svg>
)
export const IconDelete32 = ({ className, onClick }) => (
  <svg
    className={className}
    fill="none"
    height="32"
    onClick={onClick}
    viewBox="0 0 32 32"
    width="32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5 13C15.0523 13 15.5 13.4477 15.5 14V20.5C15.5 21.0523 15.0523 21.5 14.5 21.5C13.9477 21.5 13.5 21.0523 13.5 20.5V14C13.5 13.4477 13.9477 13 14.5 13Z"
      fill="#FF212C"
    />
    <path
      d="M19.5 14C19.5 13.4477 19.0523 13 18.5 13C17.9477 13 17.5 13.4477 17.5 14V20.5C17.5 21.0523 17.9477 21.5 18.5 21.5C19.0523 21.5 19.5 21.0523 19.5 20.5V14Z"
      fill="#FF212C"
    />
    <path
      clipRule="evenodd"
      d="M14.1445 5C13.7793 5 13.4431 5.19908 13.2676 5.51932L11.9078 8H6.5C5.94772 8 5.5 8.44772 5.5 9C5.5 9.55228 5.94772 10 6.5 10H8V26C8 26.5523 8.44772 27 9 27H24C24.5523 27 25 26.5523 25 26V10H26.5C27.0523 10 27.5 9.55228 27.5 9C27.5 8.44772 27.0523 8 26.5 8H21.098L19.7695 5.5268C19.5952 5.20239 19.2568 5 18.8885 5H14.1445ZM18.8277 8L18.2906 7H14.7367L14.1886 8H18.8277ZM10 10V25H23V10H10Z"
      fill="#FF212C"
      fillRule="evenodd"
    />
  </svg>
)

export const IconResend32 = ({ className, onClick }) => (
  <svg
    className={className}
    fill="none"
    height="32"
    onClick={onClick}
    viewBox="0 0 32 32"
    width="32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.1459 10.35C20.6959 8.9 18.7059 8 16.4959 8C12.0759 8 8.50586 11.58 8.50586 16C8.50586 20.42 12.0759 24 16.4959 24C20.2259 24 23.3359 21.45 24.2259 18H22.1459C21.3259 20.33 19.1059 22 16.4959 22C13.1859 22 10.4959 19.31 10.4959 16C10.4959 12.69 13.1859 10 16.4959 10C18.1559 10 19.6359 10.69 20.7159 11.78L17.4959 15H24.4959V8L22.1459 10.35Z"
      fill="#50565E"
    />
  </svg>
)
export const IconMerge32 = ({ className, onClick }) => (
  <svg
    className={className}
    fill="none"
    height="32"
    onClick={onClick}
    viewBox="0 0 32 32"
    width="32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 5C6.17158 5 5.5 5.67158 5.5 6.5V25.5C5.5 26.3284 6.17159 27 7 27H14C14.8284 27 15.5 26.3284 15.5 25.5V21C15.5 20.4477 15.0523 20 14.5 20C13.9477 20 13.5 20.4477 13.5 21V25H7.5V17H12.1825L11.4804 17.7021C11.0899 18.0926 11.0899 18.7257 11.4804 19.1163C11.8709 19.5068 12.504 19.5068 12.8946 19.1163L15.2811 16.7298C15.4686 16.5423 15.574 16.2879 15.574 16.0227C15.574 15.7575 15.4686 15.5032 15.2811 15.3156L12.8946 12.9291C12.5041 12.5386 11.8709 12.5386 11.4804 12.9291C11.0899 13.3196 11.0899 13.9528 11.4804 14.3433L12.1371 15H7.5V7H13.5V11C13.5 11.5523 13.9477 12 14.5 12C15.0523 12 15.5 11.5523 15.5 11V6.5C15.5 5.67159 14.8284 5 14 5H7Z"
      fill="#50565E"
    />
    <path
      d="M19 5C18.1716 5 17.5 5.67159 17.5 6.5V11C17.5 11.5523 17.9477 12 18.5 12C19.0523 12 19.5 11.5523 19.5 11V7H25.5V15H20.9247L21.5814 14.3433C21.9719 13.9528 21.9719 13.3196 21.5814 12.9291C21.1908 12.5386 20.5577 12.5386 20.1671 12.9291L17.8845 15.2118C17.7728 15.2992 17.6801 15.4098 17.6137 15.5364C17.4017 15.9169 17.4574 16.4065 17.7807 16.7298L20.1672 19.1163C20.5577 19.5068 21.1909 19.5068 21.5814 19.1163C21.9719 18.7257 21.9719 18.0926 21.5813 17.7021L20.8792 17H25.5V25H19.5V21C19.5 20.4477 19.0523 20 18.5 20C17.9477 20 17.5 20.4477 17.5 21V25.5C17.5 26.3284 18.1716 27 19 27H26C26.8284 27 27.5 26.3284 27.5 25.5V6.5C27.5 5.67159 26.8284 5 26 5H19Z"
      fill="#50565E"
    />
  </svg>
)

export const IconDownload14 = ({ className, onClick }) => (
  <svg
    className={className}
    fill="none"
    height="15"
    onClick={onClick}
    viewBox="0 0 14 15"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.05484 4.58363C1.98959 2.79041 3.9332 1.75919 5.94216 1.99057C7.79808 2.20433 9.35475 3.45481 9.9774 5.18845H10.2235C11.5823 5.18756 12.9404 5.90573 13.3897 7.32387C13.8205 8.68359 13.3202 10.1656 12.1535 10.9861C11.8899 11.1714 11.5261 11.108 11.3408 10.8445C11.1554 10.5809 11.2188 10.2171 11.4824 10.0318C12.2328 9.50406 12.5546 8.55082 12.2775 7.67624C12.019 6.86026 11.2091 6.35436 10.2244 6.35512L9.54698 6.35512C9.28065 6.35512 9.04814 6.17474 8.98195 5.91677C8.59946 4.42615 7.33748 3.32566 5.80867 3.14958C4.27984 2.97349 2.80074 3.75826 2.08939 5.12291C1.37803 6.48756 1.58173 8.14953 2.60158 9.302C2.81508 9.54327 2.79258 9.91193 2.55131 10.1254C2.31005 10.3389 1.94139 10.3164 1.72789 10.0752C0.38775 8.56075 0.120087 6.37685 1.05484 4.58363Z"
      fill="#50565E"
    />
    <path
      d="M7.00001 6.62506C7.32218 6.62491 7.58347 6.88595 7.58362 7.20812L7.58541 11.0484L8.44386 10.19C8.67167 9.96215 9.04101 9.96215 9.26882 10.19C9.49662 10.4178 9.49662 10.7871 9.26882 11.0149L7.44525 12.8385C7.34685 12.9529 7.20479 13.0288 7.0449 13.0402C6.88108 13.0527 6.71298 12.9964 6.5877 12.8711L4.73153 11.0149C4.50372 10.7871 4.50372 10.4178 4.73153 10.19C4.95933 9.96215 5.32868 9.96215 5.55649 10.19L6.41875 11.0522L6.41695 7.20866C6.4168 6.8865 6.67785 6.62521 7.00001 6.62506Z"
      fill="#50565E"
    />
  </svg>
)

export const IconUnarchive14 = ({ className, onClick }) => {
  return (
    <svg
      className={className}
      onClick={onClick}
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.58768 3.58744C6.81549 3.35963 7.18484 3.35963 7.41264 3.58744L9.74598 5.92077C9.97378 6.14858 9.97378 6.51793 9.74598 6.74573C9.51817 6.97354 9.14882 6.97354 8.92102 6.74573L7.5835 5.40821V9.24992C7.5835 9.57209 7.32233 9.83325 7.00016 9.83325C6.678 9.83325 6.41683 9.57209 6.41683 9.24992V5.40821L5.07931 6.74573C4.8515 6.97354 4.48216 6.97354 4.25435 6.74573C4.02654 6.51793 4.02654 6.14858 4.25435 5.92077L6.58768 3.58744Z"
        fill="#50565E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.583496 2.54159C0.583496 1.73617 1.23641 1.08325 2.04183 1.08325H11.9585C12.7639 1.08325 13.4168 1.73617 13.4168 2.54159V12.4583C13.4168 13.2637 12.7639 13.9166 11.9585 13.9166H2.04183C1.23641 13.9166 0.583496 13.2637 0.583496 12.4583V2.54159ZM1.75016 2.54159C1.75016 2.3805 1.88075 2.24992 2.04183 2.24992H11.9585C12.1196 2.24992 12.2502 2.3805 12.2502 2.54159V9.83325H9.62516C9.40421 9.83325 9.20223 9.95809 9.10341 10.1557L8.68131 10.9999H5.31902L4.89691 10.1557C4.7981 9.95809 4.59611 9.83325 4.37516 9.83325H1.75016V2.54159ZM1.75016 12.4583C1.75016 12.6193 1.88075 12.7499 2.04183 12.7499H11.9585C12.1196 12.7499 12.2502 12.6193 12.2502 12.4583V10.9999H9.98568L9.56358 11.8441C9.46477 12.0418 9.26278 12.1666 9.04183 12.1666H4.9585C4.73755 12.1666 4.53556 12.0418 4.43675 11.8441L4.01464 10.9999H1.75016V12.4583Z"
        fill="#50565E"
      />
    </svg>
  )
}

export const IconArchive14 = ({ className, onClick }) => (
  <svg
    className={className}
    fill="none"
    height="15"
    onClick={onClick}
    viewBox="0 0 14 15"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M2.04232 2.25004C1.88123 2.25004 1.75065 2.38062 1.75065 2.54171V9.83337H4.37565C4.5966 9.83337 4.79859 9.95821 4.8974 10.1558L5.3195 11H8.6818L9.1039 10.1558C9.20271 9.95821 9.4047 9.83337 9.62565 9.83337H12.2507V2.54171C12.2507 2.38062 12.1201 2.25004 11.959 2.25004H2.04232ZM13.4173 2.54171C13.4173 1.73629 12.7644 1.08337 11.959 1.08337H2.04232C1.2369 1.08337 0.583984 1.73629 0.583984 2.54171V12.4584C0.583984 13.2638 1.2369 13.9167 2.04232 13.9167H11.959C12.7644 13.9167 13.4173 13.2638 13.4173 12.4584V2.54171ZM12.2507 11H9.98617L9.56407 11.8442C9.46525 12.0419 9.26327 12.1667 9.04232 12.1667H4.95898C4.73803 12.1667 4.53605 12.0419 4.43723 11.8442L4.01513 11H1.75065V12.4584C1.75065 12.6195 1.88123 12.75 2.04232 12.75H11.959C12.1201 12.75 12.2507 12.6195 12.2507 12.4584V11ZM7.00065 3.41671C7.32282 3.41671 7.58398 3.67787 7.58398 4.00004V7.84175L8.9215 6.50423C9.14931 6.27642 9.51866 6.27642 9.74646 6.50423C9.97427 6.73203 9.97427 7.10138 9.74646 7.32919L7.41313 9.66252C7.18532 9.89033 6.81598 9.89033 6.58817 9.66252L4.25484 7.32919C4.02703 7.10138 4.02703 6.73203 4.25484 6.50423C4.48264 6.27642 4.85199 6.27642 5.0798 6.50423L6.41732 7.84175V4.00004C6.41732 3.67787 6.67848 3.41671 7.00065 3.41671Z"
      fill="#50565E"
      fillRule="evenodd"
    />
  </svg>
)
export const IconResend14New = ({ className, onClick }) => (
  <svg
    className={className}
    fill="none"
    height="15"
    onClick={onClick}
    viewBox="0 0 14 15"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.2926 4.20408C9.44677 3.35825 8.28594 2.83325 6.99677 2.83325C4.41844 2.83325 2.33594 4.92158 2.33594 7.49992C2.33594 10.0783 4.41844 12.1666 6.99677 12.1666C9.1726 12.1666 10.9868 10.6791 11.5059 8.66658H10.2926C9.81427 10.0258 8.51927 10.9999 6.99677 10.9999C5.06594 10.9999 3.49677 9.43075 3.49677 7.49992C3.49677 5.56908 5.06594 3.99992 6.99677 3.99992C7.9651 3.99992 8.82844 4.40242 9.45844 5.03825L7.5801 6.91658H11.6634V2.83325L10.2926 4.20408Z"
      fill="#50565E"
    />
  </svg>
)

export const IconSend14 = ({ className, onClick }) => (
  <svg
    className={className}
    fill="none"
    height="15"
    onClick={onClick}
    viewBox="0 0 14 15"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M12.9542 1.54587C13.1126 1.70433 13.1663 1.93954 13.0923 2.15105L9.21309 13.2344C9.13408 13.4601 8.92526 13.6148 8.68628 13.6245C8.4473 13.6343 8.22659 13.4972 8.12945 13.2786L6.0039 8.49612L1.22142 6.37057C1.00286 6.27343 0.865738 6.05272 0.875488 5.81374C0.885238 5.57476 1.03988 5.36594 1.26563 5.28693L12.349 1.40777C12.5605 1.33374 12.7957 1.38742 12.9542 1.54587ZM7.14161 8.18337L8.59798 11.4602L11.1466 4.17833L7.14161 8.18337ZM10.3217 3.35337L3.0398 5.90204L6.31665 7.35841L10.3217 3.35337Z"
      fill="#50565E"
      fillRule="evenodd"
    />
  </svg>
)

export const IconReject14 = ({ className, onClick }) => (
  <svg
    className={className}
    fill="none"
    height="15"
    onClick={onClick}
    viewBox="0 0 14 15"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M2.62435 2.83329C2.46327 2.83329 2.33268 2.96388 2.33268 3.12496V11.875C2.33268 12.036 2.46327 12.1666 2.62435 12.1666H5.54391C5.86607 12.1666 6.12724 12.4278 6.12724 12.75C6.12724 13.0721 5.86607 13.3333 5.54391 13.3333H2.62435C1.81893 13.3333 1.16602 12.6804 1.16602 11.875V3.12496C1.16602 2.31954 1.81893 1.66663 2.62435 1.66663H11.3743C12.1798 1.66663 12.8327 2.31954 12.8327 3.12496V6.05049C12.8327 6.37266 12.5715 6.63382 12.2493 6.63382C11.9272 6.63382 11.666 6.37266 11.666 6.05049V3.12496C11.666 2.96388 11.5354 2.83329 11.3743 2.83329H2.62435ZM7.12016 6.79581C7.34797 7.02362 7.34797 7.39297 7.12016 7.62077L6.35588 8.38505H12.2493C12.5715 8.38505 12.8327 8.64622 12.8327 8.96838V12.4583C12.8327 12.9415 12.4409 13.3333 11.9577 13.3333H8.46849C8.14633 13.3333 7.88516 13.0721 7.88516 12.75C7.88516 12.4278 8.14633 12.1666 8.46849 12.1666H11.666V9.55172H6.37606L7.12016 10.2958C7.34797 10.5236 7.34797 10.893 7.12016 11.1208C6.89236 11.3486 6.52301 11.3486 6.2952 11.1208L4.5452 9.37077C4.3174 9.14297 4.3174 8.77362 4.5452 8.54581L6.2952 6.79581C6.52301 6.56801 6.89236 6.56801 7.12016 6.79581Z"
      fill="#50565E"
      fillRule="evenodd"
    />
  </svg>
)

export const IconX18 = ({ className, onClick }) => (
  <svg
    className={className}
    fill="none"
    height="18"
    onClick={onClick}
    viewBox="0 0 19 18"
    width="19"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M5.09467 4.71967C5.38756 4.42678 5.86244 4.42678 6.15533 4.71967L9.375 7.93934L12.5947 4.71967C12.8876 4.42678 13.3624 4.42678 13.6553 4.71967C13.9482 5.01256 13.9482 5.48744 13.6553 5.78033L10.4357 9L13.6553 12.2197C13.9482 12.5126 13.9482 12.9874 13.6553 13.2803C13.3624 13.5732 12.8876 13.5732 12.5947 13.2803L9.375 10.0607L6.15533 13.2803C5.86244 13.5732 5.38756 13.5732 5.09467 13.2803C4.80178 12.9874 4.80178 12.5126 5.09467 12.2197L8.31434 9L5.09467 5.78033C4.80178 5.48744 4.80178 5.01256 5.09467 4.71967Z"
      fill="#50565E"
      fillRule="evenodd"
    />
  </svg>
)

// onClick = { onClick }
// className = { className }
export const IconDeactivate14 = () => (
  <svg
    fill="none"
    height="15"
    viewBox="0 0 14 15"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.78715 4.46317C4.55935 4.23537 4.19 4.23537 3.9622 4.46317C3.73439 4.69098 3.73439 5.06032 3.9622 5.28813L9.2122 10.5381C9.44 10.7659 9.80935 10.7659 10.0372 10.5381C10.265 10.3103 10.265 9.94098 10.0372 9.71317L4.78715 4.46317Z"
      fill="#FF212C"
    />
    <path
      clipRule="evenodd"
      d="M6.99967 1.08398C3.45585 1.08398 0.583008 3.95682 0.583008 7.50065C0.583008 11.0445 3.45585 13.9173 6.99967 13.9173C10.5435 13.9173 13.4163 11.0445 13.4163 7.50065C13.4163 3.95682 10.5435 1.08398 6.99967 1.08398ZM1.74967 7.50065C1.74967 4.60115 4.10018 2.25065 6.99967 2.25065C9.89917 2.25065 12.2497 4.60115 12.2497 7.50065C12.2497 10.4001 9.89917 12.7507 6.99967 12.7507C4.10018 12.7507 1.74967 10.4001 1.74967 7.50065Z"
      fill="#FF212C"
      fillRule="evenodd"
    />
  </svg>
)

export const IconActivate14 = () => (
  <svg
    fill="none"
    height="15"
    viewBox="0 0 14 15"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.58301 1.66732C7.58301 1.34515 7.32184 1.08398 6.99967 1.08398C6.67751 1.08398 6.41634 1.34515 6.41634 1.66732V2.83398C6.41634 3.15615 6.67751 3.41732 6.99967 3.41732C7.32184 3.41732 7.58301 3.15615 7.58301 2.83398V1.66732Z"
      fill="#50565E"
    />
    <path
      d="M10.4215 2.74056C10.5826 2.46156 10.487 2.1048 10.208 1.94371C9.92901 1.78263 9.57225 1.87822 9.41116 2.15722L8.82783 3.16757C8.66674 3.44658 8.76233 3.80334 9.04134 3.96442C9.32034 4.12551 9.6771 4.02992 9.83819 3.75091L10.4215 2.74056Z"
      fill="#50565E"
    />
    <path
      d="M12.5567 4.29232C12.7178 4.57132 12.6222 4.92808 12.3432 5.08917L11.3328 5.6725C11.0538 5.83358 10.697 5.73799 10.536 5.45898C10.3749 5.17998 10.4705 4.82322 10.7495 4.66214L11.7598 4.0788C12.0388 3.91772 12.3956 4.01331 12.5567 4.29232Z"
      fill="#50565E"
    />
    <path
      d="M11.6663 6.91732C11.3442 6.91732 11.083 7.17848 11.083 7.50065C11.083 7.82282 11.3442 8.08398 11.6663 8.08398H12.833C13.1552 8.08398 13.4163 7.82282 13.4163 7.50065C13.4163 7.17848 13.1552 6.91732 12.833 6.91732H11.6663Z"
      fill="#50565E"
    />
    <path
      d="M10.536 9.54232C10.697 9.26331 11.0538 9.16772 11.3328 9.3288L12.3432 9.91214C12.6222 10.0732 12.7178 10.43 12.5567 10.709C12.3956 10.988 12.0388 11.0836 11.7598 10.9225L10.7495 10.3392C10.4705 10.1781 10.3749 9.82132 10.536 9.54232Z"
      fill="#50565E"
    />
    <path
      d="M9.83819 11.2504C9.67711 10.9714 9.32034 10.8758 9.04134 11.0369C8.76234 11.198 8.66674 11.5548 8.82783 11.8338L9.41116 12.8441C9.57224 13.1231 9.929 13.2187 10.208 13.0577C10.487 12.8966 10.5826 12.5398 10.4215 12.2608L9.83819 11.2504Z"
      fill="#50565E"
    />
    <path
      d="M6.99967 11.584C7.32184 11.584 7.58301 11.8452 7.58301 12.1673V13.334C7.58301 13.6561 7.32184 13.9173 6.99967 13.9173C6.67751 13.9173 6.41634 13.6561 6.41634 13.334V12.1673C6.41634 11.8452 6.67751 11.584 6.99967 11.584Z"
      fill="#50565E"
    />
    <path
      d="M5.17152 11.8338C5.33261 11.5548 5.23701 11.198 4.95801 11.0369C4.679 10.8758 4.32224 10.9714 4.16116 11.2504L3.57783 12.2608C3.41674 12.5398 3.51234 12.8966 3.79134 13.0577C4.07034 13.2187 4.42711 13.1231 4.58819 12.8441L5.17152 11.8338Z"
      fill="#50565E"
    />
    <path
      d="M3.46338 9.54231C3.62446 9.82132 3.52887 10.1781 3.24987 10.3392L2.23951 10.9225C1.96051 11.0836 1.60375 10.988 1.44267 10.709C1.28158 10.43 1.37717 10.0732 1.65618 9.91214L2.66653 9.3288C2.94553 9.16772 3.30229 9.26331 3.46338 9.54231Z"
      fill="#50565E"
    />
    <path
      d="M1.16634 6.91732C0.844175 6.91732 0.583008 7.17848 0.583008 7.50065C0.583008 7.82282 0.844175 8.08398 1.16634 8.08398H2.33301C2.65517 8.08398 2.91634 7.82282 2.91634 7.50065C2.91634 7.17848 2.65517 6.91732 2.33301 6.91732H1.16634Z"
      fill="#50565E"
    />
    <path
      d="M1.44267 4.29232C1.60375 4.01331 1.96051 3.91772 2.23951 4.0788L3.24987 4.66214C3.52887 4.82322 3.62446 5.17998 3.46338 5.45899C3.30229 5.73799 2.94553 5.83358 2.66653 5.6725L1.65618 5.08916C1.37717 4.92808 1.28158 4.57132 1.44267 4.29232Z"
      fill="#50565E"
    />
    <path
      d="M4.58819 2.15722C4.4271 1.87822 4.07034 1.78263 3.79134 1.94371C3.51234 2.1048 3.41674 2.46156 3.57783 2.74056L4.16116 3.75091C4.32225 4.02992 4.67901 4.12551 4.95801 3.96442C5.23701 3.80334 5.33261 3.44658 5.17152 3.16757L4.58819 2.15722Z"
      fill="#50565E"
    />
  </svg>
)
export const IconResend14 = () => (
  <svg
    fill="none"
    height="15"
    viewBox="0 0 14 15"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.2926 4.20482C9.44677 3.35898 8.28594 2.83398 6.99677 2.83398C4.41844 2.83398 2.33594 4.92232 2.33594 7.50065C2.33594 10.079 4.41844 12.1673 6.99677 12.1673C9.1726 12.1673 10.9868 10.6798 11.5059 8.66732H10.2926C9.81427 10.0265 8.51927 11.0007 6.99677 11.0007C5.06594 11.0007 3.49677 9.43148 3.49677 7.50065C3.49677 5.56982 5.06594 4.00065 6.99677 4.00065C7.9651 4.00065 8.82844 4.40315 9.45844 5.03898L7.5801 6.91732H11.6634V2.83398L10.2926 4.20482Z"
      fill="#50565E"
    />
  </svg>
)

export const ShowEye = () => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M4.125 12C5.4225 8.7075 8.625 6.375 12.375 6.375C16.125 6.375 19.3275 8.7075 20.625 12C19.3275 15.2925 16.125 17.625 12.375 17.625C8.625 17.625 5.4225 15.2925 4.125 12ZM18.99 12C17.7525 9.4725 15.2175 7.875 12.375 7.875C9.5325 7.875 6.9975 9.4725 5.76 12C6.9975 14.5275 9.525 16.125 12.375 16.125C15.225 16.125 17.7525 14.5275 18.99 12ZM12.375 10.125C13.41 10.125 14.25 10.965 14.25 12C14.25 13.035 13.41 13.875 12.375 13.875C11.34 13.875 10.5 13.035 10.5 12C10.5 10.965 11.34 10.125 12.375 10.125ZM9 12C9 10.14 10.515 8.625 12.375 8.625C14.235 8.625 15.75 10.14 15.75 12C15.75 13.86 14.235 15.375 12.375 15.375C10.515 15.375 9 13.86 9 12Z"
      fill="#50565E"
      fillRule="evenodd"
    />
  </svg>
)

export const BackArrow = ({ className }) => (
  <svg
    className={className}
    fill="none"
    height="11"
    viewBox="0 0 7 11"
    width="7"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M6.15533 0.46967C6.44822 0.762563 6.44822 1.23744 6.15533 1.53033L2.18566 5.5L6.15533 9.46967C6.44822 9.76256 6.44822 10.2374 6.15533 10.5303C5.86244 10.8232 5.38756 10.8232 5.09467 10.5303L0.59467 6.03033C0.301777 5.73744 0.301777 5.26256 0.59467 4.96967L5.09467 0.46967C5.38756 0.176777 5.86244 0.176777 6.15533 0.46967Z"
      fill="white"
      fillRule="evenodd"
    />
  </svg>
)

export const IconEclipseBlue = ({ className }) => (
  <svg
    className={className}
    fill="none"
    height="14"
    viewBox="0 0 14 14"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="7" cy="7" fill="#24C9FD" r="7" />
  </svg>
)

export const IconGroup = () => (
  <svg
    fill="none"
    height="25"
    viewBox="0 0 24 25"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M11.2929 2.29289C11.6834 1.90237 12.3166 1.90237 12.7071 2.29289L16.2071 5.79289C16.5976 6.18342 16.5976 6.81658 16.2071 7.20711L12.7071 10.7071C12.3166 11.0976 11.6834 11.0976 11.2929 10.7071L7.79289 7.20711C7.40237 6.81658 7.40237 6.18342 7.79289 5.79289L11.2929 2.29289ZM9.91421 6.5L12 8.58579L14.0858 6.5L12 4.41421L9.91421 6.5ZM5.29289 8.29289C5.68342 7.90237 6.31658 7.90237 6.70711 8.29289L10.2071 11.7929C10.5976 12.1834 10.5976 12.8166 10.2071 13.2071L6.70711 16.7071C6.31658 17.0976 5.68342 17.0976 5.29289 16.7071L1.79289 13.2071C1.40237 12.8166 1.40237 12.1834 1.79289 11.7929L5.29289 8.29289ZM17.2929 8.29289C17.6834 7.90237 18.3166 7.90237 18.7071 8.29289L22.2071 11.7929C22.5976 12.1834 22.5976 12.8166 22.2071 13.2071L18.7071 16.7071C18.3166 17.0976 17.6834 17.0976 17.2929 16.7071L13.7929 13.2071C13.4024 12.8166 13.4024 12.1834 13.7929 11.7929L17.2929 8.29289ZM3.91421 12.5L6 14.5858L8.08579 12.5L6 10.4142L3.91421 12.5ZM15.9142 12.5L18 14.5858L20.0858 12.5L18 10.4142L15.9142 12.5ZM9.91421 18.5L12 20.5858L14.0858 18.5L12 16.4142L9.91421 18.5ZM11.2929 14.2929C11.6834 13.9024 12.3166 13.9024 12.7071 14.2929L16.2071 17.7929C16.5976 18.1834 16.5976 18.8166 16.2071 19.2071L12.7071 22.7071C12.3166 23.0976 11.6834 23.0976 11.2929 22.7071L7.79289 19.2071C7.40237 18.8166 7.40237 18.1834 7.79289 17.7929L11.2929 14.2929Z"
      fill="#50565E"
      fillRule="evenodd"
    />
  </svg>
)
export const IconPeople = () => (
  <svg
    fill="none"
    height="15"
    viewBox="0 0 14 15"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.04607 8.08353C9.10194 8.08384 9.15624 8.08425 9.20905 8.08478L9.50848 8.08948L9.77553 8.09765L10.0137 8.10996C10.5762 8.14646 10.9017 8.22789 11.2406 8.40057C11.7894 8.6802 12.2357 9.12641 12.5153 9.67523L12.5438 9.73242L12.5956 9.84525L12.6409 9.95841C12.648 9.97746 12.6548 9.99664 12.6613 10.016L12.6977 10.1351C12.7033 10.1555 12.7087 10.1762 12.7138 10.1973L12.7423 10.3289C12.7466 10.3518 12.7507 10.3751 12.7546 10.399L12.776 10.5496L12.7932 10.7165L12.8067 10.9026L12.8169 11.1108L12.8269 11.471L12.8326 12.0557L12.8332 12.7493C12.8332 13.0715 12.572 13.3327 12.2498 13.3327H1.74984C1.4276 13.3327 1.1665 13.0714 1.1665 12.7492L1.16672 12.0422L1.1686 11.7068L1.1733 11.4074L1.18148 11.1403L1.19379 10.9021C1.23028 10.3397 1.31172 10.0141 1.4844 9.67522C1.76403 9.12641 2.21023 8.6802 2.75905 8.40056C3.12055 8.21638 3.46682 8.136 4.10166 8.10325L4.35384 8.09309L4.63664 8.08674L4.95361 8.08353H9.04607ZM9.02591 9.25012H4.97475L4.56782 9.25496L4.23338 9.26544L4.04561 9.27609L3.88245 9.29005L3.74084 9.30762L3.61775 9.32914C3.54117 9.34487 3.47491 9.36343 3.4149 9.38527L3.32905 9.42051L3.28869 9.44007C2.95941 9.60785 2.69169 9.87558 2.52391 10.2049C2.51043 10.2313 2.49784 10.2586 2.48609 10.2872L2.45333 10.3773C2.43816 10.4249 2.42476 10.4765 2.41297 10.5339L2.39145 10.657L2.37387 10.7985L2.35992 10.9616L2.34508 11.2533L2.33659 11.6105L2.33317 12.166H11.6659L11.6642 11.7946L11.6608 11.5332L11.6519 11.2014L11.6432 11.0158L11.6318 10.8551L11.6176 10.7162L11.6001 10.5959L11.5791 10.4912C11.5753 10.4748 11.5714 10.459 11.5673 10.4436L11.5406 10.3564L11.5097 10.2768L11.4758 10.2049C11.308 9.87559 11.0403 9.60786 10.711 9.44008C10.6845 9.4266 10.6573 9.41401 10.6287 9.40226L10.5385 9.3695C10.491 9.35433 10.4394 9.34094 10.382 9.32914L10.2589 9.30763L10.1174 9.29005L9.9543 9.27609L9.66267 9.26126L9.3055 9.25277L9.02591 9.25012ZM6.99984 1.66602C8.44959 1.66602 9.62484 2.84127 9.62484 4.29102C9.62484 5.74077 8.44959 6.91602 6.99984 6.91602C5.55009 6.91602 4.37484 5.74077 4.37484 4.29102C4.37484 2.84127 5.55009 1.66602 6.99984 1.66602ZM6.99984 2.83268C6.19442 2.83268 5.5415 3.4856 5.5415 4.29102C5.5415 5.09643 6.19442 5.74935 6.99984 5.74935C7.80525 5.74935 8.45817 5.09643 8.45817 4.29102C8.45817 3.4856 7.80525 2.83268 6.99984 2.83268Z"
      fill="#50565E"
    />
  </svg>
)
export const IconSteeringWheel = () => (
  <svg
    fill="none"
    height="15"
    viewBox="0 0 14 15"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M0.583496 7.50065C0.583496 3.95682 3.45633 1.08398 7.00016 1.08398C10.544 1.08398 13.4168 3.95682 13.4168 7.50065C13.4168 11.0445 10.544 13.9173 7.00016 13.9173C3.45633 13.9173 0.583496 11.0445 0.583496 7.50065ZM1.7822 6.91732H4.14184C4.41208 5.58601 5.5891 4.58398 7.00016 4.58398C8.41123 4.58398 9.58825 5.58601 9.85849 6.91732H12.2181C11.9279 4.29235 9.70249 2.25065 7.00016 2.25065C4.29784 2.25065 2.07238 4.29235 1.7822 6.91732ZM12.2181 8.08398H9.85849C9.62651 9.22681 8.72633 10.127 7.5835 10.359V12.7186C10.0169 12.4496 11.9491 10.5174 12.2181 8.08398ZM6.41683 12.7186V10.359C5.274 10.127 4.37382 9.22681 4.14184 8.08398H1.7822C2.05121 10.5174 3.98339 12.4496 6.41683 12.7186ZM7.00016 5.75065C6.03366 5.75065 5.25016 6.53415 5.25016 7.50065C5.25016 8.46716 6.03366 9.25065 7.00016 9.25065C7.96667 9.25065 8.75016 8.46716 8.75016 7.50065C8.75016 6.53415 7.96667 5.75065 7.00016 5.75065Z"
      fill="#50565E"
      fillRule="evenodd"
    />
  </svg>
)

export const IconAddCircleOutline = () => (
  <svg
    fill="none"
    height="15"
    viewBox="0 0 14 15"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M6.99984 1.66602C3.77984 1.66602 1.1665 4.27935 1.1665 7.49935C1.1665 10.7193 3.77984 13.3327 6.99984 13.3327C10.2198 13.3327 12.8332 10.7193 12.8332 7.49935C12.8332 4.27935 10.2198 1.66602 6.99984 1.66602ZM6.4165 4.58268V6.91602H4.08317V8.08268H6.4165V10.416H7.58317V8.08268H9.9165V6.91602H7.58317V4.58268H6.4165ZM2.33317 7.49935C2.33317 10.0718 4.42734 12.166 6.99984 12.166C9.57234 12.166 11.6665 10.0718 11.6665 7.49935C11.6665 4.92685 9.57234 2.83268 6.99984 2.83268C4.42734 2.83268 2.33317 4.92685 2.33317 7.49935Z"
      fill="#50565E"
      fillRule="evenodd"
    />
  </svg>
)
export const IconRemoveCircleOutline = () => (
  <svg
    fill="none"
    height="15"
    viewBox="0 0 14 15"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M6.99984 1.66602C3.77984 1.66602 1.1665 4.27935 1.1665 7.49935C1.1665 10.7193 3.77984 13.3327 6.99984 13.3327C10.2198 13.3327 12.8332 10.7193 12.8332 7.49935C12.8332 4.27935 10.2198 1.66602 6.99984 1.66602ZM2.33317 7.49935C2.33317 10.0718 4.42734 12.166 6.99984 12.166C9.57234 12.166 11.6665 10.0718 11.6665 7.49935C11.6665 4.92685 9.57234 2.83268 6.99984 2.83268C4.42734 2.83268 2.33317 4.92685 2.33317 7.49935ZM4.08317 8.08268H9.9165V6.91602H4.08317V8.08268Z"
      fill="#FF212C"
      fillRule="evenodd"
    />
  </svg>
)
export const IconRemoveCircleOutline24 = ({ onClick }) => (
  <svg
    fill="none"
    height="24"
    onClick={onClick}
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M12.375 4.5C8.235 4.5 4.875 7.86 4.875 12C4.875 16.14 8.235 19.5 12.375 19.5C16.515 19.5 19.875 16.14 19.875 12C19.875 7.86 16.515 4.5 12.375 4.5ZM6.375 12C6.375 15.3075 9.0675 18 12.375 18C15.6825 18 18.375 15.3075 18.375 12C18.375 8.6925 15.6825 6 12.375 6C9.0675 6 6.375 8.6925 6.375 12ZM8.625 11.25V12.75H16.125V11.25H8.625Z"
      fill="#FF212C"
      fillRule="evenodd"
    />
  </svg>
)
export const IconXCircle24 = ({ className, onClick }) => (
  <svg
    className={className}
    fill="none"
    height="24"
    onClick={onClick}
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M4.125 12C4.125 7.44365 7.81865 3.75 12.375 3.75C16.9314 3.75 20.625 7.44365 20.625 12C20.625 16.5564 16.9314 20.25 12.375 20.25C7.81865 20.25 4.125 16.5564 4.125 12ZM12.375 5.25C8.64708 5.25 5.625 8.27208 5.625 12C5.625 15.7279 8.64708 18.75 12.375 18.75C16.1029 18.75 19.125 15.7279 19.125 12C19.125 8.27208 16.1029 5.25 12.375 5.25ZM9.72337 9.34833C10.0163 9.05544 10.4911 9.05544 10.784 9.34833L12.375 10.9393L13.966 9.34833C14.2589 9.05544 14.7338 9.05544 15.0267 9.34833C15.3196 9.64123 15.3196 10.1161 15.0267 10.409L13.4357 12L15.0267 13.591C15.3196 13.8839 15.3196 14.3587 15.0267 14.6516C14.7338 14.9445 14.2589 14.9445 13.966 14.6516L12.375 13.0606L10.784 14.6516C10.4911 14.9445 10.0163 14.9445 9.72337 14.6516C9.43048 14.3587 9.43048 13.8839 9.72337 13.591L11.3144 12L9.72337 10.409C9.43048 10.1161 9.43048 9.64123 9.72337 9.34833Z"
      fill="#50565E"
      fillRule="evenodd"
    />
  </svg>
)
export const IconUser = ({ className, onClick }) => (
  <svg
    className={className}
    fill="none"
    height="24"
    onClick={onClick}
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM14.1 8C14.1 6.84 13.16 5.9 12 5.9C10.84 5.9 9.9 6.84 9.9 8C9.9 9.16 10.84 10.1 12 10.1C13.16 10.1 14.1 9.16 14.1 8ZM18.1 17C18.1 16.36 14.97 14.9 12 14.9C9.03 14.9 5.9 16.36 5.9 17V18.1H18.1V17ZM4 17C4 14.34 9.33 13 12 13C14.67 13 20 14.34 20 17V20H4V17Z"
      fill="#50565E"
      fillRule="evenodd"
    />
  </svg>
)
export const IconLink = () => (
  <svg
    fill="none"
    height="14"
    viewBox="0 0 14 14"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.85655 2.78987C9.76776 1.87864 11.2452 1.87864 12.1564 2.78987C13.0372 3.6707 13.0666 5.08059 12.2445 5.99674L12.1564 6.08971L7.0004 11.2457C5.74748 12.4986 3.71607 12.4986 2.46314 11.2457C1.24501 10.0275 1.21117 8.07359 2.36163 6.81459L2.46314 6.70841L6.79416 2.37738C7.02196 2.14958 7.39131 2.14958 7.61911 2.37738C7.8294 2.58766 7.84557 2.91855 7.66764 3.14738L7.61911 3.20234L3.28809 7.53337C2.49077 8.33068 2.49077 9.6234 3.28809 10.4207C4.05694 11.1896 5.28642 11.217 6.08817 10.5031L6.17545 10.4207L11.3314 5.26476C11.787 4.80913 11.787 4.07043 11.3314 3.61483C10.8998 3.18319 10.2141 3.16047 9.75572 3.54667L9.68152 3.61483L4.52554 8.77077C4.41164 8.88469 4.41164 9.06939 4.52552 9.18329C4.62678 9.28454 4.78394 9.29579 4.89762 9.21704L4.93802 9.18329L9.26903 4.85224C9.49684 4.62444 9.86619 4.62444 10.094 4.85224C10.3043 5.06252 10.3205 5.39341 10.1425 5.62224L10.094 5.6772L5.76298 10.0082C5.19345 10.5778 4.27009 10.5778 3.70055 10.0082C3.15584 9.46347 3.13215 8.59499 3.62951 8.02207L3.70057 7.94583L8.85655 2.78987Z"
      fill="#50565E"
    />
  </svg>
)

export function IconX14({ fill, className, onClick }) {
  return (
    <svg
      className={className}
      fill="none"
      height="14"
      onClick={onClick}
      viewBox="0 0 14 14"
      width="14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M3.67085 3.67085C3.89866 3.44305 4.26801 3.44305 4.49581 3.67085L7 6.17504L9.50419 3.67085C9.73199 3.44305 10.1013 3.44305 10.3291 3.67085C10.557 3.89866 10.557 4.26801 10.3291 4.49581L7.82496 7L10.3291 9.50419C10.557 9.73199 10.557 10.1013 10.3291 10.3291C10.1013 10.557 9.73199 10.557 9.50419 10.3291L7 7.82496L4.49581 10.3291C4.26801 10.557 3.89866 10.557 3.67085 10.3291C3.44305 10.1013 3.44305 9.73199 3.67085 9.50419L6.17504 7L3.67085 4.49581C3.44305 4.26801 3.44305 3.89866 3.67085 3.67085Z"
        fill={fill}
        fillRule="evenodd"
      />
    </svg>
  )
}
export function IconPlusCircle32({ className, onClick }) {
  return (
    <svg
      className={className}
      fill="none"
      height="32"
      onClick={onClick}
      viewBox="0 0 32 32"
      width="32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M16.5 6C10.98 6 6.5 10.48 6.5 16C6.5 21.52 10.98 26 16.5 26C22.02 26 26.5 21.52 26.5 16C26.5 10.48 22.02 6 16.5 6ZM15.5 11V15H11.5V17H15.5V21H17.5V17H21.5V15H17.5V11H15.5ZM8.5 16C8.5 20.41 12.09 24 16.5 24C20.91 24 24.5 20.41 24.5 16C24.5 11.59 20.91 8 16.5 8C12.09 8 8.5 11.59 8.5 16Z"
        fill="#50565E"
        fillRule="evenodd"
      />
    </svg>
  )
}

export function IconMinusCircle32({ className, onClick }) {
  return (
    <svg
      className={className}
      fill="none"
      height="32"
      onClick={onClick}
      viewBox="0 0 32 32"
      width="32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M16.5 6C10.98 6 6.5 10.48 6.5 16C6.5 21.52 10.98 26 16.5 26C22.02 26 26.5 21.52 26.5 16C26.5 10.48 22.02 6 16.5 6ZM8.5 16C8.5 20.41 12.09 24 16.5 24C20.91 24 24.5 20.41 24.5 16C24.5 11.59 20.91 8 16.5 8C12.09 8 8.5 11.59 8.5 16ZM11.5 15V17H21.5V15H11.5Z"
        fill="#50565E"
        fillRule="evenodd"
      />
    </svg>
  )
}

export function IconInfo14({ className, onClick }) {
  return (
    <svg
      className={className}
      fill="none"
      height="14"
      onClick={onClick}
      viewBox="0 0 14 14"
      width="14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.72786 3.93766C7.72786 3.53496 7.4014 3.2085 6.9987 3.2085C6.59599 3.2085 6.26953 3.53496 6.26953 3.93766C6.26953 4.34037 6.59599 4.66683 6.9987 4.66683C7.4014 4.66683 7.72786 4.34037 7.72786 3.93766Z"
        fill="#888E96"
      />
      <path
        d="M5.97786 5.8335C5.97786 5.51133 6.23903 5.25016 6.5612 5.25016H7.14453C7.4667 5.25016 7.72786 5.51133 7.72786 5.8335V9.3335H8.16536C8.48753 9.3335 8.7487 9.59466 8.7487 9.91683C8.7487 10.239 8.48753 10.5002 8.16536 10.5002H6.1237C5.80153 10.5002 5.54036 10.239 5.54036 9.91683C5.54036 9.59466 5.80153 9.3335 6.1237 9.3335H6.5612V6.41683C6.23903 6.41683 5.97786 6.15566 5.97786 5.8335Z"
        fill="#888E96"
      />
      <path
        clipRule="evenodd"
        d="M6.9987 0.583496C5.22696 0.583496 3.62199 1.30235 2.46143 2.46289C1.30089 3.62345 0.582031 5.22842 0.582031 7.00016C0.582031 8.7719 1.30088 10.3769 2.46143 11.5374C3.62199 12.698 5.22696 13.4168 6.9987 13.4168C8.77044 13.4168 10.3754 12.698 11.536 11.5374C12.6965 10.3769 13.4154 8.7719 13.4154 7.00016C13.4154 5.22842 12.6965 3.62346 11.536 2.4629C10.3754 1.30235 8.77044 0.583496 6.9987 0.583496ZM3.28638 3.28785C4.2371 2.33715 5.5488 1.75016 6.9987 1.75016C8.44859 1.75016 9.76029 2.33715 10.711 3.28785C11.6617 4.23857 12.2487 5.55027 12.2487 7.00016C12.2487 8.45006 11.6617 9.76176 10.711 10.7125C9.76029 11.6632 8.44859 12.2502 6.9987 12.2502C5.54881 12.2502 4.2371 11.6632 3.28639 10.7125C2.33569 9.76176 1.7487 8.45006 1.7487 7.00016C1.7487 5.55027 2.33568 4.23857 3.28638 3.28785Z"
        fill="#888E96"
        fillRule="evenodd"
      />
    </svg>
  )
}

export const ArrowSort = ({ className }) => (
  <svg
    className={classnames(
      'translate-y-[-2px] transform inline-block ml-1',
      className
    )}
    fill="none"
    height="14"
    viewBox="0 0 14 14"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M3.37917 4.83754C3.60697 4.60974 3.97632 4.60974 4.20413 4.83754L7.29165 7.92506L10.3792 4.83754C10.607 4.60974 10.9763 4.60974 11.2041 4.83754C11.4319 5.06535 11.4319 5.43469 11.2041 5.6625L7.70412 9.1625C7.47632 9.39031 7.10697 9.39031 6.87917 9.1625L3.37917 5.6625C3.15136 5.43469 3.15136 5.06535 3.37917 4.83754Z"
      fillRule="evenodd"
    />
  </svg>
)

export function PeoplePlusIcon(props) {
  return (
    <svg
      fill="none"
      height="15"
      viewBox="0 0 14 15"
      width="14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.71257 8.08402L6.79521 8.08456L6.87555 8.08527L7.17499 8.08997L7.44203 8.09814L7.68024 8.11045C8.2427 8.14694 8.56823 8.22838 8.90714 8.40106C9.41021 8.65739 9.82708 9.05369 10.1085 9.54069L10.1818 9.67572L10.2103 9.73291L10.2621 9.84574L10.3075 9.9589L10.3178 9.98758L10.3278 10.0165L10.3642 10.1356L10.3724 10.1665L10.3803 10.1978L10.4088 10.3294L10.4151 10.3641L10.4211 10.3995L10.4425 10.5501L10.4597 10.717L10.4732 10.9031L10.4834 11.1113L10.4934 11.4715L10.4991 12.0562L10.4997 12.7498C10.4997 13.049 10.2745 13.2955 9.98437 13.3292L9.91634 13.3332H1.16634C0.867121 13.3332 0.620533 13.1079 0.586913 12.8177L0.583008 12.7497L0.583229 12.0427L0.585108 11.7073L0.589806 11.4079L0.597981 11.1408L0.610291 10.9026C0.646786 10.3401 0.728225 10.0146 0.900905 9.67571C1.18054 9.1269 1.62673 8.68069 2.17555 8.40105C2.50693 8.23221 2.82551 8.15061 3.36529 8.11295L3.51816 8.10374L3.77035 8.09358L4.05314 8.08723L4.37011 8.08402H6.71257ZM6.69241 9.2506H4.39126L3.98432 9.25545L3.64988 9.26593L3.46211 9.27658L3.29895 9.29054L3.15734 9.30811L3.03425 9.32963C2.9832 9.34011 2.93673 9.35186 2.89365 9.36499L2.8314 9.38575L2.74556 9.421L2.7052 9.44056C2.37592 9.60834 2.1082 9.87607 1.94041 10.2054L1.92085 10.2457L1.9026 10.2877L1.86983 10.3778L1.84839 10.4524L1.82947 10.5344L1.80795 10.6574L1.79038 10.799L1.77642 10.9621L1.76158 11.2537L1.7531 11.611L1.74967 12.1665H9.33242L9.3307 11.7951L9.32726 11.5337L9.31844 11.2019L9.3097 11.0163L9.29833 10.8556L9.28406 10.7167L9.2666 10.5964L9.24565 10.4916L9.23983 10.4675L9.23378 10.4441L9.20707 10.3568L9.17617 10.2773L9.14229 10.2054C8.9745 9.87608 8.70677 9.60834 8.3775 9.44057L8.33714 9.42101L8.29519 9.40275L8.20505 9.36999L8.13046 9.34854L8.04847 9.32963L7.92542 9.30811L7.78387 9.29054L7.6208 9.27658L7.32918 9.26174L6.97201 9.25326L6.69241 9.2506ZM11.083 3.70817C11.3822 3.70817 11.6287 3.93336 11.6624 4.22347L11.6663 4.2915V5.45817H12.833C13.1552 5.45817 13.4163 5.71934 13.4163 6.0415C13.4163 6.34066 13.1912 6.58722 12.901 6.62091L12.833 6.62484H11.6663V7.7915C11.6663 8.11367 11.4052 8.37484 11.083 8.37484C10.7839 8.37484 10.5373 8.14965 10.5036 7.85953L10.4997 7.7915V6.62484H9.33301C9.01084 6.62484 8.74967 6.36367 8.74967 6.0415C8.74967 5.74235 8.97486 5.49579 9.26498 5.4621L9.33301 5.45817H10.4997V4.2915C10.4997 3.96934 10.7608 3.70817 11.083 3.70817ZM5.54134 1.6665C6.99109 1.6665 8.16634 2.84176 8.16634 4.2915C8.16634 5.74125 6.99109 6.9165 5.54134 6.9165C4.09159 6.9165 2.91634 5.74125 2.91634 4.2915C2.91634 2.84176 4.09159 1.6665 5.54134 1.6665ZM5.54134 2.83317C4.73593 2.83317 4.08301 3.48609 4.08301 4.2915C4.08301 5.09692 4.73592 5.74984 5.54134 5.74984C6.34676 5.74984 6.99967 5.09692 6.99967 4.2915C6.99967 3.48609 6.34676 2.83317 5.54134 2.83317Z"
        fill="#50565E"
      />
    </svg>
  )
}

export function TwoPeopleIcon(props) {
  return (
    <svg
      fill="none"
      height="15"
      viewBox="0 0 14 15"
      width="14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.50975 8.0841C7.56327 8.08444 7.61502 8.08488 7.6651 8.08546L7.94652 8.09056L8.19298 8.0995C8.23142 8.10135 8.2686 8.1034 8.30464 8.10565L8.50788 8.12182C8.82637 8.15338 9.05042 8.20907 9.28247 8.30519C9.99714 8.6012 10.5649 9.16901 10.8609 9.88366L10.8831 9.93839L10.9229 10.0461L10.9571 10.1541L10.9722 10.2094L10.9988 10.3244L11.0209 10.4484C11.0242 10.47 11.0274 10.492 11.0303 10.5147L11.0463 10.6584L11.0588 10.8193L11.0682 11.0011L11.0773 11.32L11.0825 11.8495L11.083 12.7498C11.083 13.072 10.8218 13.3332 10.4996 13.3332H3.49965C3.17742 13.3332 2.91623 13.0719 2.91631 12.7497L2.91656 11.8223L2.9186 11.501L2.9237 11.2196L2.93264 10.9732C2.9345 10.9347 2.93654 10.8975 2.9388 10.8615L2.95496 10.6583C2.98652 10.3398 3.04222 10.1157 3.13834 9.88368C3.43435 9.16901 4.00216 8.6012 4.7168 8.3052C4.94887 8.20908 5.17292 8.15338 5.49141 8.12182L5.69466 8.10565C5.76673 8.10114 5.8434 8.09747 5.92548 8.0945L6.18881 8.08758L6.48954 8.0841H7.50975ZM2.96011 8.65598C3.09593 8.92252 3.00722 9.24444 2.76403 9.40618L2.70519 9.44056C2.37592 9.60834 2.1082 9.87607 1.94041 10.2054L1.92229 10.2423L1.88945 10.3191L1.86092 10.4021C1.85209 10.4311 1.84393 10.4617 1.8364 10.4944L1.81561 10.5992C1.81245 10.6179 1.80942 10.6372 1.80653 10.6572L1.79082 10.7864L1.77813 10.9357L1.76819 11.1083L1.7607 11.3071L1.75198 11.796L1.75016 12.0922L1.74967 12.7498C1.74967 13.072 1.48851 13.3332 1.16634 13.3332C0.867187 13.3332 0.620629 13.108 0.586932 12.8179L0.583008 12.7498L0.583564 12.0562L0.587612 11.5728L0.593237 11.2958L0.601828 11.0506C0.603537 11.0122 0.605391 10.975 0.607403 10.9389L0.621445 10.7347C0.653656 10.3503 0.711687 10.1024 0.814809 9.85923L0.870216 9.73745C0.880106 9.71701 0.890332 9.69646 0.900905 9.67571C1.18053 9.1269 1.62673 8.68069 2.17553 8.40106C2.46258 8.25479 2.81385 8.36892 2.96011 8.65598ZM11.8238 8.40106C12.3726 8.68069 12.8188 9.1269 13.0984 9.67572L13.1536 9.78947C13.1623 9.80825 13.1706 9.82699 13.1787 9.84574L13.2241 9.9589C13.2311 9.97795 13.2379 9.99713 13.2444 10.0165L13.2808 10.1356C13.2864 10.156 13.2918 10.1767 13.297 10.1978L13.3254 10.3294C13.334 10.3751 13.3419 10.4228 13.349 10.4729L13.3682 10.6313L13.3835 10.8075L13.4 11.1113L13.41 11.4715L13.415 11.8977L13.4163 12.7498C13.4163 13.072 13.1551 13.3332 12.833 13.3332C12.5338 13.3332 12.2872 13.108 12.2535 12.8179L12.2496 12.7498L12.2491 12.0922L12.2439 11.5353L12.2351 11.2042L12.2265 11.0189L12.2152 10.8584L12.201 10.7195C12.1984 10.698 12.1956 10.6772 12.1928 10.6572L12.1737 10.5451C12.1634 10.4927 12.1516 10.4457 12.1384 10.4021L12.1099 10.3191L12.077 10.2423C12.0712 10.2299 12.0651 10.2176 12.0589 10.2054C11.9098 9.91266 11.6816 9.6686 11.4015 9.50014L11.2941 9.44056C11.007 9.2943 10.8929 8.94303 11.0392 8.65598C11.1854 8.36893 11.5367 8.25479 11.8238 8.40106ZM7.49079 9.25068H6.50961L6.12529 9.25595L5.9147 9.26283L5.73564 9.27283L5.58381 9.28634C5.53726 9.29147 5.49454 9.29724 5.45494 9.30373L5.34474 9.3254L5.24894 9.35172C5.21894 9.36131 5.19061 9.37173 5.16327 9.38306C4.73448 9.56066 4.39381 9.90134 4.2162 10.3301C4.20487 10.3575 4.19445 10.3858 4.18486 10.4158L4.15854 10.5116L4.13688 10.6218C4.13039 10.6613 4.12461 10.704 4.11948 10.7506L4.10597 10.9023C4.10402 10.9297 4.10222 10.9583 4.10056 10.9881L4.09217 11.1822L4.08498 11.5377L4.08298 12.1665H9.91632L9.91584 11.8706L9.91132 11.3857L9.90038 11.0218L9.88679 10.8128L9.87469 10.698L9.85987 10.5989C9.85717 10.5835 9.85433 10.5687 9.85137 10.5543L9.83202 10.4729L9.80935 10.3992L9.78309 10.3301C9.60549 9.90134 9.26481 9.56066 8.83601 9.38306C8.80867 9.37173 8.78035 9.3613 8.75034 9.35171L8.65456 9.3254L8.5444 9.30373C8.50481 9.29724 8.46212 9.29147 8.4156 9.28634L8.26388 9.27283L8.08498 9.26283L7.87463 9.25596L7.49079 9.25068ZM6.99965 1.6665C8.4494 1.6665 9.62465 2.84176 9.62465 4.2915C9.62465 5.74125 8.4494 6.9165 6.99965 6.9165C5.5499 6.9165 4.37465 5.74125 4.37465 4.2915C4.37465 2.84176 5.5499 1.6665 6.99965 1.6665ZM3.97809 2.28206C4.1624 2.5463 4.09761 2.90992 3.83337 3.09423C3.44406 3.36578 3.20798 3.80827 3.20798 4.2915C3.20798 4.80923 3.47945 5.27932 3.91516 5.54187C4.19111 5.70814 4.28001 6.06663 4.11374 6.34257C3.94746 6.61851 3.58897 6.70741 3.31303 6.54114C2.53051 6.06962 2.04131 5.2225 2.04131 4.2915C2.04131 3.42279 2.46705 2.62483 3.16593 2.13734C3.43016 1.95303 3.79378 2.01783 3.97809 2.28206ZM10.8334 2.13734C11.5323 2.62483 11.958 3.42279 11.958 4.2915C11.958 5.16021 11.5322 5.95821 10.8334 6.44566C10.5691 6.62997 10.2055 6.56517 10.0212 6.30093C9.83689 6.03669 9.90169 5.67307 10.1659 5.48877C10.5552 5.21724 10.7913 4.77473 10.7913 4.2915C10.7913 3.80827 10.5552 3.36578 10.1659 3.09423C9.90169 2.90992 9.83689 2.5463 10.0212 2.28206C10.2055 2.01783 10.5691 1.95303 10.8334 2.13734ZM6.99965 2.83317C6.19423 2.83317 5.54131 3.48609 5.54131 4.2915C5.54131 5.09692 6.19423 5.74984 6.99965 5.74984C7.80507 5.74984 8.45798 5.09692 8.45798 4.2915C8.45798 3.48609 7.80506 2.83317 6.99965 2.83317Z"
        fill="#50565E"
      />
    </svg>
  )
}
;((_data) => {})([React])
